import React from 'react';
import animationData from '@/images/loading.json';
import Lottie from 'react-lottie';

const SplashScreen = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  return (
    <div>
      <Lottie options={defaultOptions} height={300} width={300} />
      {/* <svg
        className="animated"
        id="freepik_stories-flying-around-the-world"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 500 500"
        version="1.1"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        // xmlnssvgjs="http://svgjs.com/svgjs"
      >
        <style
          dangerouslySetInnerHTML={{
            __html:
              'svg#freepik_stories-flying-around-the-world:not(.animated) .animable {opacity: 0;}svg#freepik_stories-flying-around-the-world.animated #freepik--Airplane--inject-2 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}            @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        .animator-hidden { display: none; }'
          }}
        />
        <g
          id="freepik--Earth--inject-2"
          className="animable"
          style={{ transformOrigin: '247.795px 235.631px' }}
        >
          <g
            id="freepik--World--inject-2"
            className="animable"
            style={{ transformOrigin: '247.795px 235.631px' }}
          >
            <path
              d="M112.38,386.38c83.25,74.79,211.37,67.89,286.16-15.35A202.65,202.65,0,0,0,383.26,84.86C300,10.07,171.85,16.93,97.06,100.18a202.62,202.62,0,0,0,15.32,286.2Z"
              style={{ fill: '#90CAF9', transformOrigin: '247.795px 235.612px' }}
              id="elxrw3wjm8r2"
              className="animable"
            />
            <g id="elrhdhqo6eyr">
              <path
                d="M112.38,386.38c83.25,74.79,211.37,67.89,286.16-15.35A202.65,202.65,0,0,0,383.26,84.86C300,10.07,171.85,16.93,97.06,100.18a202.62,202.62,0,0,0,15.32,286.2Z"
                style={{ opacity: '0.3', transformOrigin: '247.795px 235.612px' }}
                className="animable"
                id="el494ib9ldrf8"
              />
            </g>
            <path
              d="M79.59,124.78a5.91,5.91,0,0,0,3.83.19,10.78,10.78,0,0,0,2-1c.79-.46,2.44-2.28,3-2.18s.1,2.28-.43,3.55a18.5,18.5,0,0,1-3.75,5.41c-2.42,2.31-4,2.92-5.93,3-.65,0-3.36,0-4.15,1.23s-.37,1.64.2,1.86a6.65,6.65,0,0,0,2.9-.2,2.11,2.11,0,0,1,1.25,0c1.14.51-.21,3.74.76,4.47.59.44,1.65-.06,2.47-.28a16.37,16.37,0,0,0,3.69-1.17,10.88,10.88,0,0,0,2.12-1.53A42.44,42.44,0,0,1,93,134.89,3.29,3.29,0,0,0,94.83,131c-.34-1.42-1.58-1.08-3-.26-1.87,1.1-3.94,2.71-4.5,3s-.85.32-.74-.15c.22-.91,2.46-2.28,2.86-2.59.87-.66,1.73-1.36,2.58-2,1.41-1.11,3.07-2.17,3.76-2.67a8.62,8.62,0,0,0,1.25-1,9.14,9.14,0,0,0,1.63-2c.72-1.63-.27-2.11.42-3.58a11.44,11.44,0,0,1,2.41-2.84,30.53,30.53,0,0,0,2.59-2.8c1.48-2,.92-3.86,1.8-6.09a12.48,12.48,0,0,1,2.06-3.42c1.22-1.48,2.94-3.28,3.84-4.44.54-.7,1.08-1.42,1.61-2.09a14.12,14.12,0,0,0,1.69-2.77c.31-.65.54-1.41.82-2.05A4.61,4.61,0,0,1,117,91.53a9.82,9.82,0,0,0,2.66-5c.41-2.44-1.13-1.45-1.62-1.82-.82-.62-1.85-.24-3,.26-2.43,1.08-5.17,3.16-8,4.77q-5.16,5-10,10.41c-2.79,3.1-5.43,6.29-8,9.52a6,6,0,0,0,2.28.2c1.87,0,4.29-2.63,6.41-4,.94-.61,3.73-2.84,4.17-1.93.68,1.42-2.37,4.13-3,4.68a4.53,4.53,0,0,0-1.36,1.66c-.58,1.38-1.63,3.29-2.74,2.92a4.67,4.67,0,0,0-2.06-.57,1.29,1.29,0,0,0-1.15,1c-.4,1.23-1.93,3.49-2.58,2.34-.38-.68-.6-1.72-1.25-1.88s-1.2.08-1.69-.12a2.4,2.4,0,0,1-.27-.16c-2.51,3.34-4.92,6.74-7.2,10.2A4.25,4.25,0,0,0,79.59,124.78Z"
              style={{ fill: 'rgb(55, 71, 79)', transformOrigin: '96.7268px 112.837px' }}
              id="el36l7j00tov1"
              className="animable"
            />
            <path
              d="M291.77,72.72a25.5,25.5,0,0,1,4.77-5.36q1.31-1.1,2.7-2.1c.57-.41,1.15-.8,1.73-1.19a11.09,11.09,0,0,0,1.46-.75,1.59,1.59,0,0,0-.77-2.66,2.5,2.5,0,0,0-.68-.17,2,2,0,0,0-1.5.58,13.4,13.4,0,0,1-3.85,2c-5.71,2-9.9,5.38-10.48,11.14a28.85,28.85,0,0,0-.28,6.15c.15.73.28,1.48-.46,1.79-.47.2-.64.42-.29,1,.9,1.51,2.81,2.3,4.28,2.75a27.81,27.81,0,0,0,2.94,1c1.38.23,2.87-.1,3.45-1,.45-.67-.66-1.74-1.36-2.55-.27-.31-.56-.58-.83-.86a9.83,9.83,0,0,1-1.74-3.28,7.9,7.9,0,0,1-.32-2.23A8.57,8.57,0,0,1,291.77,72.72Z"
              style={{ fill: 'rgb(55, 71, 79)', transformOrigin: '293.409px 73.7294px' }}
              id="elak0xthhggmv"
              className="animable"
            />
            <path
              d="M201,71.89c.64.39,1.27,1,1.9,1.42a9.87,9.87,0,0,0,2.37,1.15,25.38,25.38,0,0,1,2.84,1.13,1.85,1.85,0,0,1,.37.31c.41.45.18.38.25.77.13.72.69,1,1.48,1.21.62.15,1.32.45,2,.7,1.11.4,3,.21,3-.86a7.9,7.9,0,0,0-.33-2.1,16.4,16.4,0,0,1-.74-3.46,4.35,4.35,0,0,0-.06-.5c0-.27.5-.78,1.46-.55.65.16,1.36.42,1.75.51a6.44,6.44,0,0,1,.68.16c.39.13.51.66.55.84a.56.56,0,0,0,.23.32,1.64,1.64,0,0,0,.77.26,9.05,9.05,0,0,0,2.68.26,3.27,3.27,0,0,0,1-.29,1,1,0,0,0-.23-1.71,28.61,28.61,0,0,1-4.13-1,9.41,9.41,0,0,1-2.54-1.59c-1.44-1.29-.37-1.9.59-2.15a12.27,12.27,0,0,0,2.23-.8,5.07,5.07,0,0,0,2.51-2.44,2.36,2.36,0,0,0-.56-1.76l-.16-.12a3.37,3.37,0,0,0-3.3-.14c-1.19.42-2.53.81-3.81,1.12a9.09,9.09,0,0,1-1.71.4,4.31,4.31,0,0,0-1.36.09,5.54,5.54,0,0,0-1.89,1.47,4.23,4.23,0,0,1-2.35,1.38c-.54.11-1.5,0-1.37.71.18,1,1.61,1.54,2.07,2.41.35.66-.54.6-1.2.18s-.86-1.24-1.47-1.63-.88-.06-.9.24c0,.54.31,1.25-.8.86-.62-.22-1-.64-1.63-.66-1.1,0-3.15,1.27-1.79,2.84A5.41,5.41,0,0,0,201,71.89Z"
              style={{ fill: 'rgb(55, 71, 79)', transformOrigin: '211.267px 69.9341px' }}
              id="elzbm7w0bcxqs"
              className="animable"
            />
            <path
              d="M224.82,161.24c-1.38-1.29-3.88-1.51-4.17-4-.1-.8.69-1.75.18-2.55-.28-.45-.8-.41-1.19-.54s-2.27-1.09-2.31-1.8c0-.48-4,.17-3.24,1.41,1,1.83-2,3.3-.18,4.18l.22.11c.13.06.06,1.25.53,2.61s2.57,1.39,3,2.55,2.09-.26,3,.63,1.47,3.18.51,3.9.09,2.88-.5,3.62c-.39.47-.79.93-.15,1.59.38.4,1.49-.84,1.81.28.26.93-1.09,1.58-.42,2.44.55.7,1.61.19,2.19,0,2.47-.89,5.67-2.51,6.79-5.26.43-1,1.19-3.58-.23-4.13-.55-.21-1.13-.08-1.7-.4a7.29,7.29,0,0,1-1.68-1.69A27.09,27.09,0,0,0,224.82,161.24Z"
              style={{ fill: 'rgb(55, 71, 79)', transformOrigin: '222.396px 164.11px' }}
              id="elikn6m77ont8"
              className="animable"
            />
            <path
              d="M55.54,290.46c1,.62,3.22,3.14,4.29,2.8,1.87-.58-1.34-3.79-1.93-4.24s-5.43-5.36-5.38-5.43a.75.75,0,0,0,.12-.81c-.12-.22-1.31-.69-2.22-1.32.55,2.42,1.16,4.83,1.81,7.23C53.26,289.41,54.77,290,55.54,290.46Z"
              style={{ fill: 'rgb(55, 71, 79)', transformOrigin: '55.4143px 287.376px' }}
              id="eltic9sggfpop"
              className="animable"
            />
            <path
              d="M357.49,314.21a66.91,66.91,0,0,0-.43-14.71c-.15-.94-.32-1.92-.55-2.87a8.65,8.65,0,0,0-1.61-3.55,7.87,7.87,0,0,1-.81-.67c-.17-.18-.35-.43-.54-.67a3.37,3.37,0,0,0-.68-.72c-.42-.3-1.59.57-1.54,2,0,.89.22,1.87.3,2.54.46,3.58-1.93,5.93-3,8.89-1.43,4.12.21,7.67,1.05,11.42.54,2.44.2,6,1.6,8C355.9,330.09,357.23,318,357.49,314.21Z"
              style={{ fill: 'rgb(55, 71, 79)', transformOrigin: '352.888px 308.289px' }}
              id="ela4rgt2ptd1u"
              className="animable"
            />
            <path
              d="M448.19,245.92a2.44,2.44,0,0,0-2.12-.82,32.68,32.68,0,0,0-4.95,1.28,6.25,6.25,0,0,1-2.76.25A2.86,2.86,0,0,1,437,246c-.94-.86-1-2.35-1.19-3.79a5.48,5.48,0,0,0-2.16-3.69c-.47-.41-.95-.86-1.42-1.24-.76-.62-1.67-.75-2.42-1.4a4.5,4.5,0,0,1-1.68-2.58,2.82,2.82,0,0,1,.35-1.82,5.17,5.17,0,0,0-.32-3.88c-.41-.68-.88-1.3-1.19-1.78a23.47,23.47,0,0,0-2-2.48c-.35-.4-.78-.59-1.12-1-2.05-2.38-4.49-6.49-4.95-10.05-.15-1.11-.05-2.29.89-2.48a1.71,1.71,0,0,1,.88.12,9,9,0,0,1,2.12,1.5c.59.52,1.17,1,1.32,1,1.83-.63,3.66,6.18,5.43,2.74.55-1.06,1.49-1.83,2.09-2.9a11.56,11.56,0,0,0,.66-1.37,10.71,10.71,0,0,0,.66-4.13,9.19,9.19,0,0,0-.62-2.57,14,14,0,0,0-3.16-4.51,13.82,13.82,0,0,0-2.27-2c-.83-.53-1.35-.75-1.69-1.94-.73-2.54.69-6,3.11-5.78a3.65,3.65,0,0,0,3.81-1.79c1.1-1.71,1.9-3.54,3.45-4.75,2-1.56,4.68-3.32,5.92-5.67l.34-.65a201.53,201.53,0,0,0-8.74-23.68c-.36-.82-1-2.17-1.51-3.33a203.42,203.42,0,0,0-83.35-90.5,11.24,11.24,0,0,1-1.2.4,29.75,29.75,0,0,0-5.6,1.79A5.21,5.21,0,0,0,339,65.51a4.82,4.82,0,0,1-1.07,2.56,5.21,5.21,0,0,1-2.86,1.34c-.8.19-2.37.49-1.73,1.73s3,2.4,4,3.4c2.24,2.25-1.95,1-3,.67a10.34,10.34,0,0,0-3.62-.61c-.67.05-2.23,0-2.09.77s1.18,1.62,1.72,2.19c.8.84,1,1.15.3,1.55s-1.49.73-2.2,1.12a7.58,7.58,0,0,1-3.83,1.14c-1.84-.09-3.53-1.6-4.83-3.18a5.44,5.44,0,0,0-2.27-2,5,5,0,0,0-2.61-.51c-1.7.26-1.54,1.92-.79,3.51s-.64,2.43.23,3.88,2.57,2.39,4,3.25c1.22.73,3.28,1.68,3.13,2.94-.22,1.81-2.8,1.1-4.6.49-2.45-.81-4.87-1.3-7.33-2.13a13.65,13.65,0,0,0-6.28-.51c-1.08.16-1.6.88,0,1.88.73.46,3,1.06,3.06,2.18s-2.38,1.42-3.12,1.7a27,27,0,0,1-6.45,1.87c-1.75.19-3.73-.07-5.19.64a8.67,8.67,0,0,0-1.91,1.25,5.21,5.21,0,0,0-1.35,2.8,1.12,1.12,0,0,1-.43.7,3.34,3.34,0,0,1-.78.46A2.61,2.61,0,0,1,284.25,99c-.3-1-.55-2-1.58-2.41a4.28,4.28,0,0,0-3.41.56,1.33,1.33,0,0,0-.38,1.18c.08.81,1.09,2.81,1.29,4.32a3.4,3.4,0,0,1-.4,2.4,7.94,7.94,0,0,1-1.49,1.28,3.93,3.93,0,0,0-1.18,2.44c-.37,1.84-.61,3.49-2.19,4.29s-3,.45-5.08-.92a39.83,39.83,0,0,1-4.34-3.08c-2-1.79,1.36-1.53,2.25-1.57,1.33-.06,2.52-.44,3.81-.58a12.81,12.81,0,0,0,3.08-.7c.78-.3,2.16-.85,1.7-2.14-1-2.87-7.62-4.56-9.55-5.12-.93-.28-1.86-.52-2.78-.74-1.53-.37-4.13-.93-5.8-1.25a7.93,7.93,0,0,0-2.87-.18c-1.41.3-2,2.42-4.26.09-1.35-1.38-2.07-1.81-3.65-1.79a14,14,0,0,0-7.89,2.55,7.68,7.68,0,0,0-1.61,1.7c-.76,1.06-1.36,2.92-2,3.53a2.78,2.78,0,0,1-1.49.71c-3.42.56-3.77,3.85-3,8,.2,1.1.58,2.32.69,3.42a7.1,7.1,0,0,1-.1,1.85c-.17,1-.64,3.22-.95,5.08-.19,1.11-.41,2.25-.61,3.44-.54,3.3-1.28,6.72-2,10.29-.54,2.53-.81,5.31.35,7.79a7.81,7.81,0,0,0,4.49,3.74c2.22.86,3.87,0,5.39-1.12,2.23-1.61,3.67-.66,5.71,2,.89,1.17,1.83,2.63,3.15,3.12a4.66,4.66,0,0,0,4-.42c1.21-.85,1.27-2.46.61-4.15a5.15,5.15,0,0,1-.16-4.31c.59-1.35.07-2.74-.82-4.05-1.44-2.1-3.94-4.57-4.71-6a6.79,6.79,0,0,1-.83-2.65,11,11,0,0,1,0-2.31c.15-1.19,1.18-3.57,1.81-5.7a12.48,12.48,0,0,0,.54-4.24,6.87,6.87,0,0,1,.14-2,2.79,2.79,0,0,1,2.68-1.51,2.59,2.59,0,0,1,1.9,1c1.05,1.21.93,3.34.77,4.38-.24,1.57-1.37,2.24-1.74,3.7s.36,3.63,1,5.44,1.15,4,2.53,5.16c1.72,1.47,3.93.35,5.44-.21.68-.25,1.44-.54,2.23-.76a8.33,8.33,0,0,1,3.5-.27c.62.18,1.58,1.51,1.12,2a3.28,3.28,0,0,1-1,.57c-1.48.64-3.13.91-4.62,1.49-.95.37-2.53.73-2.24,2.29.21,1.2,1.59,1.85,2.42,2.39s1.77,1.15,1.86,2.24a.93.93,0,0,1-.87,1.06,4.65,4.65,0,0,1-2.52-.82c-.52-.3-1.27-1-1.7-.56-.69.67.62,3.42.94,4.32.54,1.57,1,3.35.63,4.77-.91,3.05-4.27,3.92-6.91,4.58a29,29,0,0,1-5,.45,8.6,8.6,0,0,1-3.31-.14c-2.57-.93-2.58-5.25-3.74-7.48-1.35-2.62-3.13,0-3.08,1.77.09,2.8,3.05,5.24,2.91,7.93-.09,1.87-2.12,2.51-3.29,3.41-1.61,1.25-2,3.46-1.6,5.72.2,1.24-.45,2.13-.89,3.11-.6,1.33-1.37,2.49-2,3.72a3.7,3.7,0,0,1-2.18,2c-.64.2-1.7,0-2,.56-.44.75.24,1.51-.61,2.16s-2.35.61-3.38,1.08c-.7.31-1.61,1.13-.64,1.84s2.43.66,3.39.94c2,.57,3.16,2.36,4,4.43,1.12,2.83,1.09,5.36-1.57,6.42s-5.39,1.23-7.72,3.26c-2,1.76-.63,6.26.13,8.79a5,5,0,0,0,1.64,2.68c.64.61,1.1,1.54,1.86,2a4,4,0,0,0,3.11,0,3.64,3.64,0,0,1,3.14.21,4.78,4.78,0,0,0,.74.3c.43.08.66-1.1,1.37-1.49a5.12,5.12,0,0,1,1.43-.39,4.47,4.47,0,0,0,1.4-.33c.42-.23.48-.76.77-1,1.16-.87,1.36-2.42,1.37-3.94,0-.74-.07-1.5,0-2.24,0-.89.39-1.62.51-2.49a13.55,13.55,0,0,1,.15-1.83c.35-1.18,1.29-1.28,2.12-1.85a3.13,3.13,0,0,0,1.27-3.24c-.12-1.11-.53-2.31.34-3,.7-.58,1.82-.25,2.67-.47,1.47-.38,2.32-1.75,3.34-2.78,2-2.08,4.22-1.88,6.5.25a21.66,21.66,0,0,0,3.25,2.67c.9.56,1.88.74,2.78,1.31,1.14.72,2.4,1.14,3.49,1.83,1.29.82,1.62,2.72,1.71,4.17,0,.58-.13,1.57.4,1.94s1-.31,1.22-.75c.7-1.45.09-2.79-.39-4.39-.23-.74-.6-1.6-.06-2,.23-.16.59-.09.92-.08.51,0,0-1.56-1.26-2a4.19,4.19,0,0,0-2.18-.34c-.52.12-2.37-1.31-2.9-1.61a31.26,31.26,0,0,1-3.92-2.55,6.52,6.52,0,0,1-2.4-2.85c-.53-1.8,1.3-2.19,2.51-1.69,1,.41,1.36,1.43,2.1,2.2,1.63,1.7,3.82,1.49,5.68,2.09,1.31.41,1.59,1.4,2.44,2.57a18.46,18.46,0,0,1,2,2.64c.35.73.34.85,1,1.28a11.46,11.46,0,0,0,1.9,1,8.32,8.32,0,0,1,1.81.8c.59.46.4.45.49,1.08.19,1.37.54,2.72,1.94,3.08,1.59.4,1-2.09,1.14-3.18a2.51,2.51,0,0,0-.27-2.21c-.44-.63-1.29-.86-1.77-1.45-1.24-1.51.41-1.82,1-2.61.77-1,1.46-2.54,3.11-1.93.95.36,1,1,1.16,1.89a8.31,8.31,0,0,0,1.46,2.65,11.62,11.62,0,0,0,1.52,2.57,7.11,7.11,0,0,0,6.35,1.64c.87-.25,1.46-1.18,2.39-1.22.4,0,.75.23,1.13.28a4.18,4.18,0,0,0,2-.35c.84-.3,1.58-.83,2.45-1.09,1.4-.42,1.94-.14,2.06,1.59a61.89,61.89,0,0,0,.87,7.83c.19,1,1.14,3.24.76,4.08-.46,1-2.28,0-3.07-.18a13.2,13.2,0,0,0-6.75.84,28.92,28.92,0,0,1-3.38,1.09c-.91.21-2.4.67-3.36.29-2-.82-7.37-3.29-8.3,0-.63,2.22,1,5.56-2,5.86-1.47.14-2.88-.48-4.31-.8a31,31,0,0,0-6.47-.66,7.51,7.51,0,0,1-4.35-1.17c-1.87-1.32.16-2.51-.09-4.3a4.93,4.93,0,0,0-2.68-3.75c-1.19-.44-2.57,0-3.7.42-.61.21-1.21.21-1.83.38a8.27,8.27,0,0,0-1.84,1.11A20.66,20.66,0,0,1,248,206.6c-.77.25-1.53.49-2.27.75-.44.16-1.66.37-1.92.8-1.4,2.29-3.26,4.86-6,5.46-1.7.37-3.25.26-4.71,1.44a16.23,16.23,0,0,0-3.38,4.37c-.8,1.33-1.51,2.72-2.21,4.12-.82,1.64-.24,3.32.32,5.13a4.87,4.87,0,0,1,0,3.24,10.93,10.93,0,0,1-2.71,4.68c-1.31,1.39-2.76,2.89-3.17,4.94a29.07,29.07,0,0,0-.76,5.75c0,3.79,1.07,8.06,3.82,11.06.73.79.37,4,.46,5.06a9.8,9.8,0,0,0,1.9,5.37,8.91,8.91,0,0,0,3,2.5c2.28,1.22,4.06,3.38,6.19,5.06a37.23,37.23,0,0,0,6.39,4.2,13.81,13.81,0,0,0,9,1.45,8.19,8.19,0,0,0,4-1.84,6.06,6.06,0,0,1,2-1.19,13.42,13.42,0,0,0,4.24-2.51c.63-.65,1.23-1.36,1.8-2,1.27-1.41,2.66-2.35,4.63-2.14a7.73,7.73,0,0,1,2.29.69,20.07,20.07,0,0,0,4.49,1.62,6.14,6.14,0,0,0,2.2-.12,5.3,5.3,0,0,1,3.66.52c3.09,1.65,2.72,5.22,2.18,8.38-.5,2.94,1.32,5.25,3.1,7,.85.84,1.56,1.76,2.4,2.55a10.55,10.55,0,0,1,2.57,2.87c.57,1.11,1.18,2.1,1.75,3.12a26.74,26.74,0,0,1,2.33,6.75c.22,1.16.37,2.34.48,3.52.05.58.1,1.16.14,1.74a19.21,19.21,0,0,1,0,3.23,9.86,9.86,0,0,0-.12,1.48,18,18,0,0,0,.44,3.56c.4,2,1,5.39,1.47,7.34A16,16,0,0,0,299,330c2.24,4.83,5.28,9,8.18,13.18,1.4,2,2.7,4.13,4.06,6.12.69,1,1.28,2.15,2,3.11a17,17,0,0,1,1.77,3.54c1.22,2.45,2.52,3.78,4.74,3.78,1.86,0,3.55-1.17,5.06-2.21a22.78,22.78,0,0,0,7.83-9.47,29,29,0,0,0,2-8.25,17.54,17.54,0,0,0,.24-4c-.12-1.42-.36-2.85-.38-4.29,0-2.19-.18-4.55-.08-6.73.15-3.42-.15-6.24,1.37-9.26a44.57,44.57,0,0,1,2.41-3.91c1.34-2.09,3.86-5.59,3-8.82-3.95-15.32-11.72-25.87-1.34-41,2.48-5.09,5.28-13.18,4.83-19.8-.21-3.14-2.71-4.45-4.36-3.16A32.52,32.52,0,0,1,337.3,241c-1,.6-2,1-3,1.58s-2.13.26-3.31.15a3.26,3.26,0,0,1-2.62-1.63c-.73-1-.91-2.24-1.54-3.31a5.67,5.67,0,0,0-2.59-2,22,22,0,0,1-5.73-4.54c-1.75-1.94-2.67-4.17-3.83-6.52a12.12,12.12,0,0,0-3.25-3.82,31.62,31.62,0,0,1-3.51-3.75c-1.08-1.34-5-5.89-3.19-7.6,1.39-1.35,4,3.06,5,4.15,1.87,2.16,3.76,4.08,5.67,6l3,2.88c1.64,1.6,3.61,3.58,4.4,4.4.48.5,1,1,1.42,1.5.76.82,2.17,1.94,2.65,3,2.09,4.59,4.3,6.77,6.9,5.82,2.38-.87,5.19-4.44,7-6.32a77.65,77.65,0,0,0,9-10.81,17.44,17.44,0,0,0,1.3-3.89,13,13,0,0,0,.85-4.61,2.72,2.72,0,0,0-2-2.71c-.8-.23-1.52.28-2.23-.06-.87-.42-1.36-1.65-2.12-2.26-1.45-1.18-2.29.21-3.23,1.2s-2.91,3.19-4.32,2.57c-1-.43-.79-1.36-1.42-2.07s-1-.17-1.66-.19c-1.64,0-2.88-2.06-4-3.29-.86-.93-2.78-3-2.76-4.47,0-2.43,3.21-.12,4.11.46a35.73,35.73,0,0,1,3.37,1.91,5.35,5.35,0,0,0,2.86,1.08,19.27,19.27,0,0,0,3.13.43c.77-.05,1.43-.55,2.26-.5a2.66,2.66,0,0,1,1.35.48,7.66,7.66,0,0,0,5.64,1c2.08-.6,4.09-1.72,6-2.45,1.38-.52,3.22-1.2,4.73-.91a9.07,9.07,0,0,1,5.21,3c1,1.31,2.17,3.24,3.88,3.56s1.65-3.45,2.76-2.87c.6.31.95,1.72,1.18,2.34a22.22,22.22,0,0,0,1.06,2.27c.87,1.72,1.73,3.46,2.63,5.2a92.3,92.3,0,0,0,5.93,10.47c1.08,1.57,2.69,4,4.42,4.07.77.06,1.6-1.22,1.87-2a8.53,8.53,0,0,0,.26-2.63,27.78,27.78,0,0,0-.17-3.42,36,36,0,0,1-.16-6.34,21.44,21.44,0,0,1,.52-2.81,22,22,0,0,1,1.78-4.87,18.3,18.3,0,0,0,1.84-3.38c.17-.53.32-1.07.47-1.6a29.16,29.16,0,0,1,1.08-3,3.05,3.05,0,0,1,.84-1.23,8.06,8.06,0,0,1,1.51-.64c1-.49,1.09-1.44,1.83-2.19s1.8-.25,2.53.22c2.07,1.35,2.89,4.23,3.82,6.59.46,1.16,1,2.68,2.18,2.49s1.67-1.11,2.84-.41,1.84,2.66,2.76,3.88,2.15,1.42,2.73,2.88c.37.95,0,1.21-.15,2.06s.18,1.33.63,2.06a4.88,4.88,0,0,1,.81,2.61,7.94,7.94,0,0,0,.08,2.62,1.19,1.19,0,0,0,1.09.82,3.48,3.48,0,0,1,2.18,1.7c.3.56.57,1.15.77,1.56a8.94,8.94,0,0,0,1,1.82c.16.18.31.31.45.45a4.64,4.64,0,0,1,.91,2,1.56,1.56,0,0,1-.29,1.43c-.31.26-.82.15-1.34,0-.75-.28-1.9-.73-2.57-.92a2.89,2.89,0,0,0-1.22-.11c-2.06.41,1.47,4.59,2.18,5.22s1.21.88,1.79,1.4a6,6,0,0,1,1.29,2,25.58,25.58,0,0,0,3.15,4.2,19,19,0,0,0,3.4,3.38,9.71,9.71,0,0,0,1.91,1.1c.19.08,2,.45,2,.52,1.29,5.89,5.16.95,7.68,2.16,2,1.18,3.83,0,5.71-.66a9.31,9.31,0,0,0,1.45-.7c0-.54.05-1.08.08-1.61A2.39,2.39,0,0,1,448.19,245.92Zm-144.4-66.87a21.81,21.81,0,0,1-5.55.06c-2.64-.14-6.18,1.81-8.41,3a8,8,0,0,1-3.51,1.07c-2.6,0-2.69-5.89-2.41-8.77a11.33,11.33,0,0,1,1-4.39c1.32-2.26,5.72-1,5.29-.17s.64,1.28,1,1.93,1.2,1.12,1.7.3-1.17-3.69.66-5.43a8.87,8.87,0,0,1,.72-.61c2-1.54,3.47-.61,3.94,2.37a6.18,6.18,0,0,0,.64,2c1.53,2.72,4.55,2.25,4.67,2.58s1.33.4,2.5,1.22S306.29,178.5,303.79,179.05Zm28.32,1.54c.15,2.31-2.27,3.5-5.05,3-2.62-.48-4.08-4.49-4.78-7.09s-5.48-3.89-6.75-6.7c-2.27-5,1-10.15,4.26-10.79,2.52-.48,1.87,3.62,1.35,6.36-.18,1,.44,1.6,1.56,2.47,2.35,1.82,4.82,2.25,6.17,3s.42,2.42-.78,3.2S331.92,177.66,332.11,180.59Z"
              style={{ fill: 'rgb(55, 71, 79)', transformOrigin: '335.705px 209.665px' }}
              id="el9lse0sonewe"
              className="animable"
            />
            <path
              d="M207.69,367.12c.36-1.93,2.57-4.34,4.31-5.69,1.36-1.06,2.37-1.38,2.91-3.57a13.53,13.53,0,0,0-.95-7.59c-.77-1.52-.49-3.32-1-4.42s-2.62-4.21-3.22-7.4c-.92-4.87,2.52-9,1.7-14.17-.51-3.21-4.55-5.33-7.09-5.76s-6.2-3.75-8.75-3l-.82.24c-2.56.74-7.26-1.59-10.09-1.86a15.52,15.52,0,0,0-1.92-.06c-2.76.07-6.59-2.22-8.72-4.78-2-2.38-4.21-4.53-6.61-5.11-3.23-.79-6.37,2.53-9.58.17a13,13,0,0,0-4.51-2.36,14.15,14.15,0,0,1-4.69-2c-2.1-1.57-3,.29-5,0-1.16-.19-1.68-.63-2.9-.3-1.56.41-3.09,1-4.68,1.28-1.3.2-1.93-.33-3.17-.83-2.81-1.16-6.17,1.17-7.08,3.57-.45,1.17-.3,2.77-.78,3.85-1,2.19-4.58,1.6-6.79,1.08a12,12,0,0,1-4.75-2.28c-1.67-1.37-2.71-1.56-3.24-3.76-.38-1.59-.62-3.71-2.13-4.79-1.26-.9-2.9-.56-4.06-.32s-2.22,1-3.35.7a3.79,3.79,0,0,1-2.47-3c0-.89.76-1.63,1-2.42a3.11,3.11,0,0,0,.18-1.37c0-.23-.54-1.13-.52-1.22.46-2-.21-2.87-1.29-3-1.92-.27-4.4,2.13-4.23,4.43s-3,4.72-5.5,4.33c-5-.75-9.33-8.5-9.45-14.51,0-2.75,1.77-7,4-8,1.8-.76,4-.52,6.17-.92.92-.09.73-.7.55-1.32-.3-1,1.7-1.5,3.13-2s4.83-.77,6.94,1.09a19.76,19.76,0,0,1,2.52,3.11c1.65,2.3,5.49,2.86,4.07.27-.89-1.62-2.35-3.58-3.39-5.42-1.45-2.56-.33-6.75,1-8.67a32.42,32.42,0,0,0,2.46-3.5c.5-1,1.29-2.44,1-3.75-.3-1.51-1.67-2.62-2-4.29a8.45,8.45,0,0,1,0-3.47,10.37,10.37,0,0,1,2.6-5c1.2-1.2,3.76-1.62,4-3.81s-.06-3.41,1.13-5.41a15,15,0,0,1,2.72-3.25c1.67-1.56,1.55,2.19,3.84,1.26,1.49-.6,3.92-2.82,5.82-5.08s2.07-5,1.15-5.64-1.73,4.35-4.14,4.46a3.25,3.25,0,0,1-.76-.06c-2.36-.47-2.92-4.14-3.3-4s-.51-.44,0-.83.21-4.43-1.86-2.91c-.34.26-.7.57-1.07.9-2,1.77-2.69,0-.75-1.77,3.06-2.84,7.19-4.34,10.93-6.4,2.24-1.24,3.42-.19,2.69,2.82s-1,4.95.84,4.84c2.46-.14,5-2,5.29-1,.18.59.37,1.14,1,.34,1-1.2,2.77.49,3.41-1.31a2.67,2.67,0,0,0-.86-2.53c-1-1.08-2.35-3.14-3.77-2.83s-2.63-3.2-2.58-6.34c0-.33,0-.65,0-1-.08-3.13-4.25-4.55-6.4-5.67-6.35-3.28-4.46-4-8.48-9.87-1.48-2.16-3.5-1.22-4.92,1.36-.76,1.36-1.6,2.43-2.43,2.53-2.14.26-2.26-6.34-3.78-6.62-.84-.16-1.87,0-2.56-1.18-1.16-2.08-3.52-2.29-5.57-1.33s-3.22,5.15-2.6,7.35-.63,6.11.45,7.5,3,5.12,1.87,7.88c-.67,1.65-1.83,3.1-2.34,4.74-.91,2.89,1.82,6.37,1.19,8a1.67,1.67,0,0,1-2,1.25A6.39,6.39,0,0,1,90,212.52c-1.21-3.41-.31-5.83-3.45-5.85a31.33,31.33,0,0,1-12.08-2.35c-1.77-.79-1.89-2.39-2.71-4.29s-2.67-2-1-5.39c1.06-2.1,3-3.89,3.31-6.72.34-2.65-2-2.36-.92-4.78s4.68-2.47,6.15-3.6a3.58,3.58,0,0,0,1.64-2.3c.37-2-1.05-1.71-1.53-2.53-.16-.26.33-.57.84-.81a5.38,5.38,0,0,0,2-1.11,3.59,3.59,0,0,0,.74-1.33,9.1,9.1,0,0,1,.31-1.5,2.64,2.64,0,0,1,1.07-1.06,6.86,6.86,0,0,0,2.53-1.74c1-1.24,2.26-2.36,2.76-4.49a8.4,8.4,0,0,0,.08-3.58c-.31-.58-1.07-.31-1.2-1.31-.43-3.28,3-4.16,4.06-4.68,1.63-.79,3.55-1.78,3.66,1.56.05,1.47.38,5,1.82,2.64.81-1.32,1.1-1.93,1.94-1.12a3,3,0,0,1,1.36,2.66,4,4,0,0,1-1.26,2.91c-1,1.17-1.46,6.08-3.36,6.93-.31.14-.62.27-.93.42-1.89.91-.89,5.58.88,4.19s4.29-.67,6,.64c2.36,1.85,5.72,3.64,7.12,3.28,2.09-.53-.18-4.78.76-5.42a5.64,5.64,0,0,1,1.75-.91c.34-.08,0-2.84-.09-3.11a4.08,4.08,0,0,0-1.25-2c-1.11-.92-2.45-.71-3.28-2.4-.93-1.89.71-4.17,1.93-3.73.58.21,1,1,1.5,1.68.75,1.15,2,1.61,2.41,1.25a3,3,0,0,0,.72-.89c.48-1,.25-1.94.6-2.9.56-1.55,1.83-1.45,2.38-2.93a1.74,1.74,0,0,0-1-2.52c-1.83-.83-3.76-1.1-5.49-1.84a9.7,9.7,0,0,1-1-.39c-.53-.29-1-1.85-1-3.06a11.49,11.49,0,0,0-.17-2.11,3.16,3.16,0,0,0-1.59-1.86,9.81,9.81,0,0,0-2.23-1.28c-1.27-.52-4,0-5.16-1.38s-2.23-3.22-3.61-2.78c-.16.06-.59.7-.8.85a1.47,1.47,0,0,1-.93.28c-.61,0-1.07-.46-1.63-.61a3.58,3.58,0,0,0-3.61,1.17,17.06,17.06,0,0,1-1.42,1.28,15.09,15.09,0,0,1-2.87,1.26,14.77,14.77,0,0,0-3.56,3.73,11.66,11.66,0,0,0-1.66,3.12c-.56,1.79-.73,4.49.36,4.53s2.78-.94,4-1.13,3.84-.93,3.35,2.06c-.38,2.26-2.77,2.18-2.54,4.73.07.83.52,1.44.24,2.57a10.45,10.45,0,0,1-1.29,2.59A16.55,16.55,0,0,1,82.15,167c-.71.74-1.88.76-2-.47-.08-1,.69-2,.72-3s-.52-1.18-1-1.33a2.74,2.74,0,0,0-.91,0,2.59,2.59,0,0,1-1.74-.78,5.74,5.74,0,0,1-.69-1c-.34-.61-.84-1.15-1.21-1.82a5.63,5.63,0,0,1,.13-4.3c.27-.43.6-.83,1-1.4a23.78,23.78,0,0,0,1.75-3.75c1-2.79,1-5.23-.8-4.65S73.25,147.8,72.6,151c-.37,1.85-.3,3.63-1,5.57-.64,1.68-1.71,3.05-2.27,4.72s-.22,2.85-.54,4.41-.65,1.26-1.35,1.94c-1.58,1.53-.76,4.64-2.22,6.47a4.41,4.41,0,0,1-1.73,1.11,6.54,6.54,0,0,1-3.18.77c-.31,0-.73,0-.64-.74.12-1,1-1.46,1.42-2,1.43-1.63,2.36-5.18,1.89-6.79-.31-1.07-1.29-.8-1.93-1.15a4.37,4.37,0,0,1-1.75-4.06q-3,7.56-5.31,15.27a.94.94,0,0,1,1,.42c.31.48.19,1.15,0,2.06a14.16,14.16,0,0,0-.33,1.71c-.13.93-.79,4.46-1.93,4a4.82,4.82,0,0,1-.84-.49,202.13,202.13,0,0,0-1.86,95,1.69,1.69,0,0,1,1.73.09c2.11,1.16,4,5,6.15,6.21,3.53,2,7.68,4.46,10.18,7.82,1.64,2.2,4,5.49,6.45,6.37,4.79,1.74,10.21,2.71,14.46,1.44s10.43,5.2,14.05,2.11c.44-.37,3.39,2.66,3.81,3.06a15.4,15.4,0,0,0,5.41,3.08,31.93,31.93,0,0,0,6.29,1.35c3.89.58,8.69,1.77,9,7.4.21,3.4-.57,6.84-.79,10.22-.23,3.58-.12,7.08,2.33,10s5.64,4.56,8,7.32,2.66,7,5.2,10c3.18,3.82,6.65,3.88,11.24,4.71a14.81,14.81,0,0,1,9.07,4.92,129,129,0,0,1,15,19.85c5.51,8.74,10.47,18.24,17.78,25.57a42.64,42.64,0,0,0,12,9c3,1.39,5.56,1,4.72-2.87-.52-2.35-2.77-3.94-4.07-5.88s-.79-3.94-1.27-6.16c-.4-1.83-2.59-4.28-1.61-6s3.1-1.12,3.42-3.24c.4-2.66-2.5-3.27-3.32-5.13s2.47-2.55,3.15-4.49c.43-1.24-.19-2.61,0-3.85.18-1,.65-1.27,1.09-2.05a10.59,10.59,0,0,0,.83-5C210.35,372.37,207.17,369.85,207.69,367.12ZM78.1,232.58c1.62-2.27,4.32-7.19,6.43-6.55a7.45,7.45,0,0,1,2.78,2.34c1.65,1.86,5,1.95,7,2.47s-.18,2.81-.09,4.65-1.06,2.79-1.2,1.78c-.09-.61-.23-1.08-1-.55-1.1.74-1-.22-.87-1.29.19-1.46-3.23-2-3.5,1a23.91,23.91,0,0,0,0,2.41c.08,3-2.67,3.46-2.72.51,0-.37,0-.75,0-1.14.12-3-1.45-6.13-3.67-5.41C78.67,233.63,76.37,235,78.1,232.58Z"
              style={{ fill: 'rgb(55, 71, 79)', transformOrigin: '130.174px 279.519px' }}
              id="elt7ps9yjbhg"
              className="animable"
            />
            <path
              d="M68.79,144.41c.59,1,1.82-.25,2-.77s1.2-3.61.3-4.62c-.44-.5-1-.25-1.63.28-.61,1.12-1.18,2.25-1.77,3.38A8.29,8.29,0,0,0,68.79,144.41Z"
              style={{ fill: 'rgb(55, 71, 79)', transformOrigin: '69.5731px 141.768px' }}
              id="elxae0776p19o"
              className="animable"
            />
            <path
              d="M211.78,175.26c1.18,1.75,2.94,0,4-.63a5.6,5.6,0,0,0,2.1-4.32,5.23,5.23,0,0,0-1.41-3.38c-.82-.85-2.77-2.2-3.63-1.19-.35.41-.07,1-.34,1.35-.39.57-1.47.46-2,.75-1.54.83.21,2.25.73,3.17a3.6,3.6,0,0,1,.43,2.1C211.6,173.78,211.33,174.6,211.78,175.26Z"
              style={{ fill: 'rgb(55, 71, 79)', transformOrigin: '213.88px 170.698px' }}
              id="elnrckligxf8"
              className="animable"
            />
            <path
              d="M256.21,194.58c.33-2.81-3.73-9.77-4-6.79a10,10,0,0,0,0,1.65C252.37,192.49,255.88,197.38,256.21,194.58Z"
              style={{ fill: 'rgb(55, 71, 79)', transformOrigin: '254.202px 191.239px' }}
              id="el1577vt9l7nr"
              className="animable"
            />
            <path
              d="M449.3,219.25c.61-2,.2-4.46-1.77-4.25s-2.35,2.43-3.35,4.31a41.85,41.85,0,0,1-4.27,6.27c-1,1.19-3.23.77-3.08,3.11a10.67,10.67,0,0,0,2.27,5.63c1,1.35,1.6,2.54,2.87,3.29,2.32,1.37,5.37,1.49,7.19-1.44a5,5,0,0,0,.62-1.52c.22-.89.29-2.59.61-3.69-.06-2.77-.2-5.53-.37-8.29A3.19,3.19,0,0,1,449.3,219.25Z"
              style={{ fill: 'rgb(55, 71, 79)', transformOrigin: '443.606px 226.764px' }}
              id="el1bo4m34vp2l"
              className="animable"
            />
            <path
              d="M119.28,282.8a11.84,11.84,0,0,1-5.7-.41c-1.8-.5-3.93-1.11-5.36,0-1.09.87.82,1.82,1.79,2.2a19.85,19.85,0,0,0,2.21.65c1.22.31,3,1.06,3.89,1.29a2.59,2.59,0,0,0,1.64-.08c2.07-.76,3.87-2.68,6.47-1.66.61.23,1.76,1.13,2.4.86a.3.3,0,0,0,.11-.06c.61-.45.13-1.66-.35-2.24C124.49,281.17,121.17,282.44,119.28,282.8Z"
              style={{ fill: 'rgb(55, 71, 79)', transformOrigin: '117.455px 284.196px' }}
              id="elqtcbf1nmot"
              className="animable"
            />
            <path
              d="M266.5,199.45a2.13,2.13,0,0,0-2-2.32c-.76-.13-.66.67-.45,1.57C264.29,199.86,266.29,201.36,266.5,199.45Z"
              style={{ fill: 'rgb(55, 71, 79)', transformOrigin: '265.204px 198.74px' }}
              id="el3jp674zod8c"
              className="animable"
            />
            <path
              d="M245.29,198c.62-1.13.18-2-2.35-1.2-.41.08-.83.94-1,1.8C241.65,199.83,244.26,199.92,245.29,198Z"
              style={{ fill: 'rgb(55, 71, 79)', transformOrigin: '243.729px 197.989px' }}
              id="elcq56vpgbheo"
              className="animable"
            />
            <path
              d="M191.42,136.1c.62-3.07-3.78-6.38-5.11-5.8-.81.35-1.41,1.35-2,1.83a15.33,15.33,0,0,1-2.67,1c-1.47.57-2.39,3.11-3.87,2s-1.28,3.73,1,6C184,146.27,190.48,140.74,191.42,136.1Z"
              style={{ fill: 'rgb(55, 71, 79)', transformOrigin: '184.152px 136.713px' }}
              id="eltv8bm3ryj4"
              className="animable"
            />
            <path
              d="M82.83,176.19c-.42,2.83-.06,5.26,1.25,5.49s3.84-2.31,5.79-3.45c2.8-1.63,0-2.38-2.55-3.88C85.64,173.36,83.26,173.35,82.83,176.19Z"
              style={{ fill: 'rgb(55, 71, 79)', transformOrigin: '86.8499px 177.721px' }}
              id="el8y030o4zxcc"
              className="animable"
            />
            <path
              d="M165.36,111.06c1.29-1.62,3.49-4.78,2-7.71-.88-1.75-2.11-2.15-2.62-4.22a7.88,7.88,0,0,1-.22-2.37,23.16,23.16,0,0,1,1-3.94,2.53,2.53,0,0,0-.34-2.14c-.86-1.27-2.23-1-3.14-1.71-4.67-3.47,4.67-15.15,3-16.93a1.7,1.7,0,0,0-1.19-.39,10.3,10.3,0,0,0-2.63.3,4.79,4.79,0,0,0-1.37.63,4.72,4.72,0,0,0-1.29,1.94c-.58,1.3-1.36,2.78-1.78,2.51-.17-.11-.33-.42-.73-.79-1.14-1.06-1,0-1.8.75-.41.39-2,1-2.53-.46s.64-3.43.88-4.36a3.75,3.75,0,0,1,1-1.8c.7-.68.08-2.66-1.5-3.47a9,9,0,0,0-4.66-.79,13.58,13.58,0,0,0-8.34,3.39,19.61,19.61,0,0,0-3.61,3.85c-1.51,2.1-2.42,6.2-4.12,8.57a3.25,3.25,0,0,1-3.34,1.46c-2.14,0-4.89,0-7.45,4.66-1.57,2.91,0,2.71-.41,5.09s-3,2.62-3.8,3.27a6.85,6.85,0,0,0-1.13,1.18,6.63,6.63,0,0,0-.64,4.24c.14.46.12.89-.88,2.39a37.75,37.75,0,0,1-4.33,5.23,9.3,9.3,0,0,0-2.57,4.89c-.39,1.93.21,1.72.85,2.13a2.51,2.51,0,0,1,.8.82c.37.6.91,2.35,1.78,2.39s3.12-1.74,4.82-3c2.88-2.06,5.69-3.71,7.91-1.46a6.59,6.59,0,0,1,1.56,2.81c.61,2,.42,6.09.3,8.34a6.1,6.1,0,0,0,.5,3.6c1.24,1.7,3.52,1.06,4.85,3,1,1.52,1,4.07.57,6.47-.55,2.68-1.75,3.92-2.57,6.28s.22,4.44.46,6.56a20.43,20.43,0,0,0,2.43,7.3,59.53,59.53,0,0,0,4.42,7,9.19,9.19,0,0,0,2.16,2.29c1.34.92,4.25.42,6.13-.61a6.79,6.79,0,0,0,2.95-3c1.49-3.16,0-7,0-10.43a8.58,8.58,0,0,1,2.87-6.77c1.63-1.48,4-2.82,5-5.2.87-2,1-4.68,2-6.54,1.34-2.48,4.25-3.19,6.08-4.65,1.26-1,3.71-3.25,3.4-5.44-.17-1.18-.75-1.66-.51-2.9a4.47,4.47,0,0,1,1.18-1.91c.2-.21.61-.44,1-.73.52-.43.35-1.93-.27-2.53-.43-.41-.91-.77-1.14-1.06C164.53,115,163.82,113,165.36,111.06Z"
              style={{ fill: 'rgb(55, 71, 79)', transformOrigin: '137.382px 117.705px' }}
              id="ele70q31dl6kv"
              className="animable"
            />
            <path
              d="M69.88,151.52c.67-.9,1.49-2,1-2.34-.15-.12-.43-.05-.59-.15s-1.51.21-3.42,2-2,4-3.35,5.15.58,3.72,2.16,4.14c2.37.63,4.35-2.35,5.24-4.91C72,152.13,68.92,152.81,69.88,151.52Z"
              style={{ fill: 'rgb(55, 71, 79)', transformOrigin: '67.1087px 154.709px' }}
              id="elxjz5h4f6rjf"
              className="animable"
            />
            <g id="elhjjvclt6bo">
              <path
                d="M272.09,50c-133.28-16.77-143.43,73.87-67.26,118s194.82,44,204.75,5.45S371.16,62.47,272.09,50Z"
                style={{
                  fill: 'rgb(255, 255, 255)',
                  opacity: '0.1',
                  transformOrigin: '284.029px 124.859px'
                }}
                className="animable"
                id="el15d7ja0zxbg"
              />
            </g>
            <g id="elqp9jqusvjds">
              <path
                d="M209.32,344.42C97.48,278.68,75.76,120.36,154.61,55.71h0c-3.48,1.81-6.93,3.69-10.34,5.71C48.09,118.63,16.48,243,73.69,339.21a202.64,202.64,0,0,0,371-55.32C422.75,327.13,321.11,410.12,209.32,344.42Z"
                style={{ opacity: '0.15', transformOrigin: '244.937px 247.004px' }}
                className="animable"
                id="elvh4do96e1f"
              />
            </g>
          </g>
        </g>
        <g
          id="freepik--Shadows--inject-2"
          className="animable animator-hidden"
          style={{ transformOrigin: '314.271px 324.322px' }}
        >
          <path
            id="freepik--Shadow--inject-2"
            d="M309.19,461.56l27.9,16.11a9.57,9.57,0,0,0,8.66,0l40.35-23.3L418.33,473a9.57,9.57,0,0,0,8.66,0l48.21-27.84c2.39-1.38,2.39-3.62,0-5L447.3,424a9.57,9.57,0,0,0-8.66,0l-16,9.22-32.23-18.6a9.51,9.51,0,0,0-8.66,0l-72.58,41.9C306.8,457.94,306.8,460.18,309.19,461.56Z"
            style={{ fill: 'rgb(224, 224, 224)', transformOrigin: '392.194px 446.141px' }}
            className="animable"
          />
          <g id="freepik--shadow--inject-2">
            <path
              d="M382.23,173.9S379,169.36,372,170s-13.6,3.42-25.09,10.06l-55.07,31.8a12.73,12.73,0,0,0-3.1-2.6,6.44,6.44,0,0,0-3.37-1h-.06l-.16,0c-4.6.16-11.27,5.34-15.25,8.88L162.39,210a9.86,9.86,0,0,0-7.58,3.42l-3.26,4.23,33.14,6.29h0a.73.73,0,0,0,.4.74l.11.08h0a1.89,1.89,0,0,0,.36.16l.18.05a3,3,0,0,0,.37.07,2.7,2.7,0,0,0,.37,0h.14l.76-.42.22-.14,7.45,1.42.12.51h0l4,17.54,4.52,20-38-.86a17.82,17.82,0,0,0-8,1.77l-3.24,1.87,40.46,9.53-.36.3-.1.08L194,277l-.15.14-.16.13,0,0h0a4.54,4.54,0,0,0-.8.62h0a6.33,6.33,0,0,0-1.33,1.8,1.3,1.3,0,0,0-.08.17c-.06.12-.1.23-.15.35a2.83,2.83,0,0,0-.11.31,1.4,1.4,0,0,0-.09.29c0,.13-.07.26-.1.39s0,.15,0,.23a4.18,4.18,0,0,0,0,.61c0,1.25.63,2,1.54,1.95v0h.14c1.19-.06,9.84-.58,24-2.79l25.31,8,2-1.13.72-.42a1.68,1.68,0,0,0,.89-1.39,2.07,2.07,0,0,0,0-.6,4.9,4.9,0,0,0-1.74-2.63l-6.57-5.66c16.73-3.92,25-8.71,37-15.59l28.93-16.7,12.4,4.82a1.57,1.57,0,0,0,.45.58,2.65,2.65,0,0,0,.35.24,3.63,3.63,0,0,0,.85.35,5.14,5.14,0,0,0,1.62.16h0l.06,0,15.28,6a1.39,1.39,0,0,0,.34.43l.28.19a3.36,3.36,0,0,0,1.3.39,4.21,4.21,0,0,0,.46,0h.21l16,6.24h0a.55.55,0,0,0,.09.14,1.33,1.33,0,0,0,.35.28,2.28,2.28,0,0,0,.94.28,2.31,2.31,0,0,0,.34,0h.11l17.16,6.69,5.61-3.24c2.26-1.3,2.44-3.69.42-5.33l-32.16-26.06a6.38,6.38,0,0,0,.47-2.53,14.75,14.75,0,0,0-5.88-11l33.57-19.39c.61-.35,1.21-.71,1.81-1.1l.52-.34,1.27-.86.55-.4c.41-.3.82-.6,1.22-.91l.5-.4,1.24-1,.43-.36c.43-.37.85-.75,1.27-1.13l.33-.3c.44-.42.88-.83,1.3-1.26l.23-.23c.46-.46.91-.93,1.34-1.41l.12-.13c.47-.52.93-1,1.36-1.57h0c3-3.62,5.09-7.38,5.65-10.71C394.11,174.88,388.26,173.84,382.23,173.9ZM227.74,250.08,210.8,229.87a3.27,3.27,0,0,0,1,.34l.3,0a4.29,4.29,0,0,0,.47,0h.18c.44-.23.9-.49,1.36-.77l21.41,4.07h0a1,1,0,0,0,.08.6,2.08,2.08,0,0,0,.2.33,2.94,2.94,0,0,0,.25.25,3.53,3.53,0,0,0,.35.24,4.67,4.67,0,0,0,2.47.51c.56-.29,1.14-.63,1.73-1l9.26,1.76C242,241,233.94,245.94,227.74,250.08Zm-17.94-21.4.3,0h0a.67.67,0,0,0,0,.29Z"
              style={{ opacity: '0.2', transformOrigin: '272.347px 229.569px' }}
              className="animable"
              id="eleaziwri6ad7"
            />
          </g>
        </g>
        <g
          id="freepik--Clouds--inject-2"
          className="animable"
          style={{ transformOrigin: '257.749px 249.844px' }}
        >
          <path
            id="freepik--Cloud--inject-2"
            d="M442.43,110.42l-.59.17c0-6.8-9.3-15.92-15.81-10.47-5.24-11.58-20.79-13.38-24.91,1.36-13.08-4.6-18.65,2.09-19.64,15-4.94-3.24-17.93-2.31-18.31,9.15-3.95-4-17.25-6.16-20.9,3.24a4.91,4.91,0,0,0-5-.91,51.32,51.32,0,0,0-5.54,2.11,20.42,20.42,0,0,1-6.28,1.49c-1,.09-3.26,0-3.94,1-1.72,2.39,5.33,2.84,6.61,2.79,3-.14,5.75-1.16,8.7-1.26a23.94,23.94,0,0,1,7.56,1.22c2.38.67,4.69,2.37,7,3.31,4.94,2,9.88,2.94,15.23,1.57,3.94-1,8-4.58,8-4.58s8.25,4.95,11.48,5.72c12.43,3,20.83-3,23.39-9,7.43,8.83,25.17,9.87,28.54-3,4.4,4.49,14.91,7.56,20,.18,2.54-3.68,1.17-10.27-4.42-10.38C454.59,111.78,448.59,108.85,442.43,110.42Z"
            style={{ fill: 'rgb(240, 240, 240)', transformOrigin: '390.244px 116.529px' }}
            className="animable"
          />
          <path
            id="freepik--cloud--inject-2"
            d="M83.54,375.7a19.69,19.69,0,0,1,4.83-10.47,13.3,13.3,0,0,1,10.31-4.37c6.63.09,15.29,4.95,17.06,11.68,1.62-3.36,10.59-1,13.23.89,3.78,2.64,6,7.79,8.64,11.52a13.65,13.65,0,0,1,5.56-3.27,10.6,10.6,0,0,1,8.93.63,15.2,15.2,0,0,1,5.82,6.23,9.79,9.79,0,0,1,5-1.1,10.78,10.78,0,0,1,6.89,3.27c.43.41,1.82,2.16,1.82,2.16s2.18-.59,2.89-.74a11.39,11.39,0,0,1,7.3,1,29.75,29.75,0,0,0,8.49,2c1.29.15,4.89-.17,5.58,1.28,1.36,2.87-4.12,3.1-5.53,3.17-2.94.14-5.15-.9-7.91-1.41-1.11,3.51-5.55,3.35-8.44,2.52l-4.91-1.44s-1.74,1.1-2.88,1.9a19.48,19.48,0,0,1-9.69,3,17.84,17.84,0,0,1-4.94-.34,28.27,28.27,0,0,1-6.55-2.22c-.76-.39-2-.88-2-.88s-2.44,2.33-3.43,3a35.3,35.3,0,0,1-4.62,2.77c-8.23,4.17-22.07,3.05-25.72-7a14.78,14.78,0,0,1-14.72,7.15c-3.9-.49-7.55-3.78-7.41-7.88-2.65,3.64-11.61,5.22-15.48,3.06-2.51-1.4-4.83-6.9-1.57-8.62-4.72,1.3-14.76.11-13.77-6.39.8-5.23,6.3-6,9.9-5C65.92,372.27,77.5,369.16,83.54,375.7Z"
            style={{ fill: 'rgb(240, 240, 240)', transformOrigin: '126.178px 384.805px' }}
            className="animable"
          />
        </g>
        <g
          id="freepik--Locators--inject-2"
          className="animable"
          style={{ transformOrigin: '245.421px 224.262px' }}
        >
          <path
            id="freepik--Pin--inject-2"
            d="M326.11,289.55a4.21,4.21,0,0,0-5.21,2.85c-1.12,3.82,1.85,8.62,1.85,8.62s5.09-2.43,6.21-6.26A4.2,4.2,0,0,0,326.11,289.55Zm-1.68,5.73a2,2,0,1,1,2.52-1.37A2,2,0,0,1,324.43,295.28Z"
            style={{ fill: '#90CAF9', transformOrigin: '324.888px 295.202px' }}
            className="animable"
          />
          <path
            id="freepik--pin--inject-2"
            d="M296.62,119.71a4.2,4.2,0,0,0-4.61,3.73c-.42,4,3.36,8.15,3.36,8.15s4.57-3.3,5-7.26A4.21,4.21,0,0,0,296.62,119.71Zm-.63,5.94a2,2,0,1,1,2.24-1.81A2,2,0,0,1,296,125.65Z"
            style={{ fill: '#90CAF9', transformOrigin: '296.185px 125.639px' }}
            className="animable"
          />
          <path
            id="freepik--pin--inject-2"
            d="M242.48,171.83a4.19,4.19,0,0,0-3.11,5.06c.92,3.87,5.88,6.56,5.88,6.56s3.21-4.64,2.29-8.52A4.2,4.2,0,0,0,242.48,171.83Zm1.39,5.81a2,2,0,1,1,1.5-2.45A2,2,0,0,1,243.87,177.64Z"
            style={{ fill: '#90CAF9', transformOrigin: '243.479px 177.582px' }}
            className="animable"
          />
          <path
            id="freepik--pin--inject-2"
            d="M424.25,159.24a4.19,4.19,0,0,0-5.43,2.4c-1.44,3.72,1.13,8.75,1.13,8.75s5.27-2,6.7-5.72A4.19,4.19,0,0,0,424.25,159.24Zm-2.15,5.57a2,2,0,1,1,2.63-1.16A2,2,0,0,1,422.1,164.81Z"
            style={{ fill: '#90CAF9', transformOrigin: '422.659px 164.672px' }}
            className="animable"
          />
          <path
            id="freepik--pin--inject-2"
            d="M185.8,324.65a4.21,4.21,0,0,0-1.72,5.69c1.88,3.51,7.36,4.84,7.36,4.84s1.92-5.3,0-8.81A4.2,4.2,0,0,0,185.8,324.65Zm2.82,5.27a2,2,0,1,1,.83-2.76A2,2,0,0,1,188.62,329.92Z"
            style={{ fill: '#90CAF9', transformOrigin: '187.939px 329.676px' }}
            className="animable"
          />
          <path
            id="freepik--pin--inject-2"
            d="M102.82,213.13a4.2,4.2,0,0,0-2.68,5.3c1.25,3.78,6.41,6,6.41,6s2.82-4.89,1.57-8.67A4.19,4.19,0,0,0,102.82,213.13Zm1.87,5.67a2,2,0,1,1,1.3-2.56A2,2,0,0,1,104.69,218.8Z"
            style={{ fill: '#90CAF9', transformOrigin: '104.185px 218.671px' }}
            className="animable"
          />
          <path
            id="freepik--pin--inject-2"
            d="M140.54,113.49a4.2,4.2,0,0,0-2.95,5.15c1,3.85,6.09,6.38,6.09,6.38s3.06-4.74,2-8.58A4.19,4.19,0,0,0,140.54,113.49Zm1.57,5.76a2,2,0,1,1,1.43-2.5A2,2,0,0,1,142.11,119.25Z"
            style={{ fill: '#90CAF9', transformOrigin: '141.674px 119.182px' }}
            className="animable"
          />
          <path
            id="freepik--pin--inject-2"
            d="M65.64,263.26a4.2,4.2,0,0,0-.93,5.87c2.34,3.22,8,3.79,8,3.79s1.18-5.51-1.16-8.73A4.19,4.19,0,0,0,65.64,263.26Zm3.51,4.83a2,2,0,1,1,.45-2.84A2,2,0,0,1,69.15,268.09Z"
            style={{ fill: '#90CAF9', transformOrigin: '68.457px 267.677px' }}
            className="animable"
          />
        </g>
        <g
          id="freepik--Luggage--inject-2"
          className="animable"
          style={{ transformOrigin: '393.188px 371.429px' }}
        >
          <g
            id="freepik--Suitcase--inject-2"
            className="animable"
            style={{ transformOrigin: '361.25px 419.804px' }}
          >
            <path
              d="M381,366.46l-63.49,36.65a4,4,0,0,0-1.79,3.1v52a3.94,3.94,0,0,0,1.79,3.09L338,473.14a3.94,3.94,0,0,0,3.57,0L405,436.48a3.94,3.94,0,0,0,1.79-3.09v-52a3.94,3.94,0,0,0-1.79-3.09l-20.47-11.82A3.94,3.94,0,0,0,381,366.46Z"
              style={{ fill: '#90CAF9', transformOrigin: '361.255px 419.81px' }}
              id="elwi4nn2qi8lg"
              className="animable"
            />
            <g id="el0v158dinace">
              <path
                d="M340.26,418.33l-24-13.88a3.59,3.59,0,0,0-.53,1.76v52a3.94,3.94,0,0,0,1.79,3.09L338,473.14a4,4,0,0,0,3.21.17c-.82.28-1.43-.2-1.43-1.2v-52A3.59,3.59,0,0,1,340.26,418.33Z"
                style={{
                  fill: 'rgb(255, 255, 255)',
                  opacity: '0.45',
                  transformOrigin: '328.47px 439.009px'
                }}
                className="animable"
                id="elbqjqfkvzbef"
              />
            </g>
            <g id="elctb5usn4bis">
              <path
                d="M340.26,418.33l-24-13.88a3.59,3.59,0,0,0-.53,1.76v52a3.94,3.94,0,0,0,1.79,3.09L338,473.14a4,4,0,0,0,3.21.17c-.82.28-1.43-.2-1.43-1.2v-52A3.59,3.59,0,0,1,340.26,418.33Z"
                style={{ opacity: '0.1', transformOrigin: '328.47px 439.009px' }}
                className="animable"
                id="el93tpa7c8fc4"
              />
            </g>
            <g id="elou9oypv89xp">
              <path
                d="M405,378.27l-20.47-11.82a4,4,0,0,0-3.57,0l-63.49,36.65a3.62,3.62,0,0,0-1.26,1.34l24,13.88a3.59,3.59,0,0,1,1.26-1.33L405,380.34c.92-.53,1.67-.16,1.78.81A4,4,0,0,0,405,378.27Z"
                style={{
                  fill: 'rgb(255, 255, 255)',
                  opacity: '0.55',
                  transformOrigin: '361.495px 392.175px'
                }}
                className="animable"
                id="ell7djjwmhjs"
              />
            </g>
            <path
              d="M341.52,473.14,405,436.49a4,4,0,0,0,1.79-3.1v-52c0-1.14-.81-1.61-1.79-1L341.52,417a3.94,3.94,0,0,0-1.79,3.09v52C339.73,473.25,340.53,473.71,341.52,473.14Z"
              style={{ fill: '#90CAF9', transformOrigin: '373.26px 426.753px' }}
              id="elcahaxml1tr8"
              className="animable"
            />
            <g id="elshylb7w47v">
              <path
                d="M341.52,473.14,405,436.49a4,4,0,0,0,1.79-3.1v-52c0-1.14-.81-1.61-1.79-1L341.52,417a3.94,3.94,0,0,0-1.79,3.09v52C339.73,473.25,340.53,473.71,341.52,473.14Z"
                style={{
                  fill: 'rgb(255, 255, 255)',
                  opacity: '0.65',
                  transformOrigin: '373.26px 426.753px'
                }}
                className="animable"
                id="elbeq0o57nfk"
              />
            </g>
            <path
              d="M342.24,468.45a.28.28,0,0,0,0,.13v1.31l1.12-.66a.27.27,0,0,0,.11-.37.28.28,0,0,0-.38-.1l-.3.17v-.35a.28.28,0,0,0-.28-.27A.27.27,0,0,0,342.24,468.45Z"
              style={{ fill: 'rgb(255, 255, 255)', transformOrigin: '342.868px 469.099px' }}
              id="el7ejwyl4m98x"
              className="animable"
            />
            <path
              d="M344.47,467.94l1.42-.81a.27.27,0,0,1,.27.47l-1.41.82a.29.29,0,0,1-.38-.1.28.28,0,0,1,0-.28A.47.47,0,0,1,344.47,467.94Zm2.83-1.63,1.41-.81a.27.27,0,0,1,.38.1.27.27,0,0,1-.1.37l-1.42.82a.27.27,0,0,1-.37-.1.28.28,0,0,1,0-.28A.32.32,0,0,1,347.3,466.31Zm2.83-1.63,1.41-.82a.27.27,0,0,1,.37.1.28.28,0,0,1-.1.38l-1.41.82a.28.28,0,0,1-.38-.11.29.29,0,0,1,0-.27A.27.27,0,0,1,350.13,464.68Zm2.82-1.63,1.41-.82a.29.29,0,0,1,.38.1.28.28,0,0,1-.1.38l-1.41.81a.27.27,0,0,1-.38-.1.26.26,0,0,1,0-.27A.24.24,0,0,1,353,463.05Zm2.83-1.63,1.41-.82a.28.28,0,0,1,.38.1.28.28,0,0,1-.11.38l-1.41.81a.27.27,0,0,1-.37-.1.24.24,0,0,1,0-.27A.19.19,0,0,1,355.78,461.42Zm2.82-1.64L360,459a.27.27,0,0,1,.27.47l-1.41.82a.28.28,0,0,1-.38-.1.26.26,0,0,1,0-.27A.36.36,0,0,1,358.6,459.78Zm2.83-1.63,1.41-.81a.28.28,0,0,1,.38.1.27.27,0,0,1-.1.37l-1.42.82a.27.27,0,0,1-.37-.1.28.28,0,0,1,0-.28A.32.32,0,0,1,361.43,458.15ZM404,386.26a.27.27,0,0,1,.28.28v1.63a.28.28,0,0,1-.55,0v-1.63a.23.23,0,0,1,0-.14A.26.26,0,0,1,404,386.26Zm-39.79,70.26,1.42-.81a.26.26,0,0,1,.37.1.27.27,0,0,1-.1.37l-1.41.82a.29.29,0,0,1-.38-.1.31.31,0,0,1,0-.28Zm39.79-67a.28.28,0,0,1,.28.28v1.63a.28.28,0,1,1-.55,0V389.8a.23.23,0,0,1,0-.14A.26.26,0,0,1,404,389.52Zm-37,65.37,1.41-.82a.29.29,0,0,1,.38.1.27.27,0,0,1-.1.38l-1.41.82a.29.29,0,0,1-.38-.1.28.28,0,0,1,0-.28A.24.24,0,0,1,367.08,454.89Zm37-62.1a.27.27,0,0,1,.28.27v1.63a.28.28,0,1,1-.55,0v-1.63a.23.23,0,0,1,0-.14A.25.25,0,0,1,404,392.79Zm-34.13,60.47,1.41-.82a.29.29,0,0,1,.38.1.28.28,0,0,1-.11.38l-1.41.81a.26.26,0,0,1-.37-.1.26.26,0,0,1,0-.27A.19.19,0,0,1,369.91,453.26ZM404,396.05a.27.27,0,0,1,.28.27V398a.28.28,0,0,1-.55,0v-1.63a.21.21,0,0,1,0-.14A.26.26,0,0,1,404,396.05Zm-31.31,55.58,1.42-.82a.27.27,0,0,1,.37.1.28.28,0,0,1-.1.38l-1.41.81a.28.28,0,0,1-.38-.1.26.26,0,0,1,0-.27A.32.32,0,0,1,372.73,451.63ZM404,399.31a.28.28,0,0,1,.28.28v1.63a.28.28,0,1,1-.55,0v-1.63a.23.23,0,0,1,0-.14A.26.26,0,0,1,404,399.31ZM375.56,450l1.41-.81a.28.28,0,0,1,.38.1.29.29,0,0,1-.1.38l-1.42.81a.27.27,0,0,1-.37-.1.26.26,0,0,1,0-.27A.21.21,0,0,1,375.56,450ZM404,402.58a.27.27,0,0,1,.28.27v1.63a.28.28,0,1,1-.55,0v-1.63a.23.23,0,0,1,0-.14A.25.25,0,0,1,404,402.58Zm-25.66,45.78,1.42-.81a.27.27,0,0,1,.27.47l-1.41.82a.28.28,0,0,1-.38-.1.31.31,0,0,1,0-.28A.47.47,0,0,1,378.38,448.36ZM404,405.84a.27.27,0,0,1,.28.27v1.64a.28.28,0,0,1-.55,0v-1.64a.2.2,0,0,1,0-.13A.26.26,0,0,1,404,405.84Zm-22.83,40.89,1.41-.81a.27.27,0,0,1,.38.1.27.27,0,0,1-.1.37l-1.41.82a.29.29,0,0,1-.38-.1.28.28,0,0,1,0-.28A.32.32,0,0,1,381.21,446.73ZM404,409.1a.28.28,0,0,1,.28.28V411a.28.28,0,0,1-.55,0v-1.63a.23.23,0,0,1,0-.14A.26.26,0,0,1,404,409.1Zm-20,36,1.41-.82a.28.28,0,0,1,.38.11.27.27,0,0,1-.11.37l-1.41.82a.27.27,0,0,1-.37-.1.28.28,0,0,1,0-.28A.24.24,0,0,1,384,445.1Zm20-32.73a.27.27,0,0,1,.28.27v1.63a.28.28,0,1,1-.55,0v-1.63a.23.23,0,0,1,0-.14A.25.25,0,0,1,404,412.37Zm-17.18,31.1,1.42-.82a.27.27,0,0,1,.37.1.28.28,0,0,1-.1.38l-1.41.81a.27.27,0,0,1-.38-.1.26.26,0,0,1,0-.27A.32.32,0,0,1,386.86,443.47ZM404,415.63a.27.27,0,0,1,.28.27v1.64a.28.28,0,0,1-.55,0V415.9a.2.2,0,0,1,0-.13A.24.24,0,0,1,404,415.63Zm-14.35,26.21,1.41-.82a.28.28,0,0,1,.38.1.29.29,0,0,1-.1.38l-1.42.81a.27.27,0,0,1-.37-.1.26.26,0,0,1,0-.27A.24.24,0,0,1,389.69,441.84ZM404,418.89a.28.28,0,0,1,.28.28v1.63a.28.28,0,0,1-.55,0v-1.63a.23.23,0,0,1,0-.14A.26.26,0,0,1,404,418.89Zm-11.53,21.32,1.42-.82a.27.27,0,0,1,.37.1.28.28,0,0,1-.1.38l-1.41.81a.28.28,0,0,1-.38-.1.29.29,0,0,1,0-.27A.32.32,0,0,1,392.51,440.21Zm11.53-18a.27.27,0,0,1,.28.27v1.63a.28.28,0,1,1-.55,0v-1.63a.23.23,0,0,1,0-.14A.25.25,0,0,1,404,422.16Zm-8.7,16.41,1.41-.81a.28.28,0,0,1,.38.1.27.27,0,0,1-.1.37l-1.41.82a.28.28,0,0,1-.38-.1.28.28,0,0,1,0-.28A.32.32,0,0,1,395.34,438.57Zm8.7-13.15a.27.27,0,0,1,.28.27v1.64a.28.28,0,0,1-.55,0v-1.64a.2.2,0,0,1,0-.13A.24.24,0,0,1,404,425.42Zm-5.87,11.52,1.41-.81a.28.28,0,0,1,.38.1.27.27,0,0,1-.11.37l-1.41.82a.27.27,0,0,1-.37-.1.26.26,0,0,1,0-.28A.24.24,0,0,1,398.17,436.94Zm5.87-8.26a.28.28,0,0,1,.28.28v1.63a.28.28,0,0,1-.55,0V429a.23.23,0,0,1,0-.14A.26.26,0,0,1,404,428.68ZM401,435.31l1.42-.82a.27.27,0,0,1,.37.11.27.27,0,0,1-.1.37l-1.41.82a.29.29,0,0,1-.38-.1.28.28,0,0,1,0-.28A.47.47,0,0,1,401,435.31ZM404,432a.27.27,0,0,1,.28.27v1.18a1.55,1.55,0,0,1-.19.51l0,0a.25.25,0,0,1-.36.07.3.3,0,0,1-.09-.39,2.25,2.25,0,0,0,.12-.26v-1.16a.23.23,0,0,1,0-.14A.24.24,0,0,1,404,432Z"
              style={{ fill: 'rgb(255, 255, 255)', transformOrigin: '374.309px 427.355px' }}
              id="elwl3tdrndd1b"
              className="animable"
            />
            <path
              d="M403.09,384.35a.28.28,0,0,0,0,.28.29.29,0,0,0,.38.1l.3-.18v.35a.28.28,0,1,0,.55,0v-1.3l-1.13.65A.32.32,0,0,0,403.09,384.35Z"
              style={{ fill: 'rgb(255, 255, 255)', transformOrigin: '403.689px 384.416px' }}
              id="el7hweat77ntp"
              className="animable"
            />
            <path
              d="M342.43,419.52a.27.27,0,0,1,.36-.07.31.31,0,0,1,.09.4,1.61,1.61,0,0,0-.12.26v1.16a.28.28,0,0,1-.28.27.27.27,0,0,1-.27-.27v-1.19a1.23,1.23,0,0,1,.19-.51Zm1.42-1,1.41-.82a.27.27,0,0,1,.37.1.27.27,0,0,1-.1.38l-1.41.81a.28.28,0,0,1-.38-.1.29.29,0,0,1,0-.27A.27.27,0,0,1,343.85,418.52Zm-1.37,4.1a.29.29,0,0,1,.28.28v1.63a.28.28,0,0,1-.28.27.27.27,0,0,1-.27-.27V422.9a.32.32,0,0,1,0-.14A.29.29,0,0,1,342.48,422.62Zm4.19-5.74,1.41-.81a.28.28,0,0,1,.38.1.27.27,0,0,1-.1.37l-1.41.82a.28.28,0,0,1-.38-.1.28.28,0,0,1,0-.28A.32.32,0,0,1,346.67,416.88Zm-4.19,9a.28.28,0,0,1,.28.27v1.63a.29.29,0,0,1-.28.28.28.28,0,0,1-.27-.28v-1.63a.32.32,0,0,1,0-.14A.28.28,0,0,1,342.48,425.89Zm7-10.64,1.41-.81a.27.27,0,0,1,.38.1.27.27,0,0,1-.1.37l-1.42.82a.27.27,0,0,1-.37-.1.28.28,0,0,1,0-.28A.24.24,0,0,1,349.5,415.25Zm-7,13.9a.28.28,0,0,1,.28.27v1.64a.28.28,0,0,1-.28.27.27.27,0,0,1-.27-.27v-1.64a.28.28,0,0,1,0-.13A.27.27,0,0,1,342.48,429.15Zm9.84-15.53,1.42-.82a.27.27,0,0,1,.37.11.27.27,0,0,1-.1.37l-1.41.82a.29.29,0,0,1-.38-.1.31.31,0,0,1,0-.28A.47.47,0,0,1,352.32,413.62Zm-9.84,18.79a.29.29,0,0,1,.28.28v1.63a.28.28,0,0,1-.28.27.27.27,0,0,1-.27-.27v-1.63a.32.32,0,0,1,0-.14A.29.29,0,0,1,342.48,432.41ZM355.15,412l1.41-.82a.28.28,0,1,1,.28.48l-1.42.82a.27.27,0,0,1-.37-.11.26.26,0,0,1,0-.27A.24.24,0,0,1,355.15,412Zm-12.67,23.69a.28.28,0,0,1,.28.27v1.63a.29.29,0,0,1-.28.28.28.28,0,0,1-.27-.28V436a.32.32,0,0,1,0-.14A.26.26,0,0,1,342.48,435.68ZM358,410.36l1.41-.82a.27.27,0,0,1,.37.1.27.27,0,0,1-.1.38l-1.41.81a.28.28,0,0,1-.38-.1.29.29,0,0,1,0-.27A.27.27,0,0,1,358,410.36Zm-15.5,28.58a.28.28,0,0,1,.28.27v1.63a.28.28,0,0,1-.28.28.27.27,0,0,1-.27-.27v-1.64a.28.28,0,0,1,0-.13A.27.27,0,0,1,342.48,438.94Zm18.32-30.21,1.41-.82a.28.28,0,0,1,.28.48l-1.41.81a.28.28,0,0,1-.38-.1.26.26,0,0,1,0-.27A.24.24,0,0,1,360.8,408.73ZM342.48,442.2a.28.28,0,0,1,.28.28v1.63a.28.28,0,0,1-.28.27.27.27,0,0,1-.27-.27v-1.63a.32.32,0,0,1,0-.14A.29.29,0,0,1,342.48,442.2Zm21.15-35.11,1.41-.81a.28.28,0,0,1,.38.1.27.27,0,0,1-.1.37l-1.42.82a.27.27,0,0,1-.37-.1.28.28,0,0,1,0-.28A.24.24,0,0,1,363.63,407.09Zm-21.15,38.38a.27.27,0,0,1,.28.27v1.63a.29.29,0,0,1-.28.28.28.28,0,0,1-.27-.28v-1.63a.32.32,0,0,1,0-.14A.26.26,0,0,1,342.48,445.47Zm24-40,1.42-.81a.27.27,0,1,1,.27.47l-1.41.82a.28.28,0,0,1-.38-.1.31.31,0,0,1,0-.28A.47.47,0,0,1,366.45,405.46Zm-24,43.27a.28.28,0,0,1,.28.27v1.63a.28.28,0,0,1-.28.28.27.27,0,0,1-.27-.28V449a.28.28,0,0,1,0-.13A.27.27,0,0,1,342.48,448.73Zm26.8-44.9,1.41-.82a.28.28,0,0,1,.38.11.27.27,0,0,1-.1.37l-1.42.82a.27.27,0,0,1-.37-.1.28.28,0,0,1,0-.28A.32.32,0,0,1,369.28,403.83ZM342.48,452a.28.28,0,0,1,.28.28v1.63a.28.28,0,0,1-.28.27.27.27,0,0,1-.27-.27v-1.63a.32.32,0,0,1,0-.14A.29.29,0,0,1,342.48,452Zm29.63-49.79,1.41-.82a.27.27,0,0,1,.37.1.28.28,0,0,1-.1.38l-1.41.82a.28.28,0,0,1-.38-.11.29.29,0,0,1,0-.27A.27.27,0,0,1,372.11,402.2Zm-29.63,53.05a.29.29,0,0,1,.28.28v1.63a.29.29,0,0,1-.28.28.28.28,0,0,1-.27-.28v-1.63a.32.32,0,0,1,0-.14A.29.29,0,0,1,342.48,455.25Zm32.45-54.68,1.41-.82a.29.29,0,0,1,.38.1.28.28,0,0,1-.1.38l-1.41.81a.27.27,0,0,1-.38-.1.26.26,0,0,1,0-.27A.24.24,0,0,1,374.93,400.57Zm-32.45,57.95a.28.28,0,0,1,.28.27v1.63a.28.28,0,0,1-.28.28.27.27,0,0,1-.27-.28v-1.63a.35.35,0,0,1,0-.14A.28.28,0,0,1,342.48,458.52Zm35.28-59.58,1.41-.82a.28.28,0,0,1,.38.1.29.29,0,0,1-.1.38l-1.42.81a.27.27,0,0,1-.37-.1.26.26,0,0,1,0-.27A.19.19,0,0,1,377.76,398.94Zm-35.28,62.84a.28.28,0,0,1,.28.28v1.63a.28.28,0,0,1-.28.27.27.27,0,0,1-.27-.27v-1.63a.32.32,0,0,1,0-.14A.29.29,0,0,1,342.48,461.78Zm38.1-64.48,1.42-.81a.27.27,0,0,1,.37.1.28.28,0,0,1-.1.38l-1.41.81a.28.28,0,0,1-.38-.1.31.31,0,0,1,0-.28ZM342.48,465a.29.29,0,0,1,.28.28V467a.29.29,0,0,1-.28.28.28.28,0,0,1-.27-.28v-1.63a.32.32,0,0,1,0-.14A.29.29,0,0,1,342.48,465Zm40.93-69.37,1.41-.81a.28.28,0,0,1,.38.1.27.27,0,0,1-.1.37l-1.42.82a.27.27,0,0,1-.37-.1.28.28,0,0,1,0-.28A.32.32,0,0,1,383.41,395.67Zm2.83-1.63,1.41-.81a.27.27,0,0,1,.27.47l-1.41.82a.29.29,0,0,1-.38-.1.31.31,0,0,1,0-.28A.36.36,0,0,1,386.24,394Zm2.82-1.63,1.41-.82a.29.29,0,0,1,.38.1.27.27,0,0,1-.1.38l-1.41.82a.29.29,0,0,1-.38-.1.28.28,0,0,1,0-.28A.24.24,0,0,1,389.06,392.41Zm2.83-1.63,1.41-.82a.28.28,0,1,1,.28.48l-1.42.81a.26.26,0,0,1-.37-.1.26.26,0,0,1,0-.27A.19.19,0,0,1,391.89,390.78Zm2.82-1.63,1.42-.82a.27.27,0,0,1,.37.1.28.28,0,0,1-.1.38l-1.41.81a.28.28,0,0,1-.38-.1.29.29,0,0,1,0-.27A.32.32,0,0,1,394.71,389.15Zm2.83-1.64,1.41-.81a.28.28,0,0,1,.38.1.29.29,0,0,1-.1.38l-1.42.81a.27.27,0,0,1-.37-.1.26.26,0,0,1,0-.27A.27.27,0,0,1,397.54,387.51Zm2.83-1.63,1.41-.81a.27.27,0,0,1,.37.1.26.26,0,0,1-.1.37l-1.41.82a.28.28,0,0,1-.38-.1.31.31,0,0,1,0-.28A.36.36,0,0,1,400.37,385.88Z"
              style={{ fill: 'rgb(255, 255, 255)', transformOrigin: '372.196px 426.137px' }}
              id="ell4qq1vshw2n"
              className="animable"
            />
            <g id="elattslw4g4so">
              <path
                d="M329.11,468V413a1.9,1.9,0,0,1,.95-1.65l66.11-38.18-2.23-1.28-66.12,38.17a1.92,1.92,0,0,0-.95,1.65v55.05Z"
                style={{ opacity: '0.1', transformOrigin: '361.52px 419.945px' }}
                className="animable"
                id="elpue1gqtuaff"
              />
            </g>
            <path
              d="M339.74,427.83l.06.05a21.75,21.75,0,0,0,8.5-14.72l-.07,0L341.52,417a4,4,0,0,0-1.79,3.1v7.72"
              style={{ fill: '#90CAF9', transformOrigin: '344.015px 420.52px' }}
              id="ell81qowo7vt"
              className="animable"
            />
            <path
              d="M406.79,381.37V388c-4.1,2.34-7.43.41-7.43-4.34,0,0,0,0,0,0l5.63-3.26C406,379.77,406.79,380.23,406.79,381.37Z"
              style={{ fill: '#90CAF9', transformOrigin: '403.075px 384.555px' }}
              id="eljjtw2l99lqo"
              className="animable"
            />
            <path
              d="M341.54,473.13l5.72-3.29c0-4.73-3.36-6.64-7.47-4.27l0,0v6.51C339.75,473.24,340.55,473.7,341.54,473.13Z"
              style={{ fill: '#90CAF9', transformOrigin: '343.524px 468.963px' }}
              id="elh8olcmvokkc"
              className="animable"
            />
            <path
              d="M406.8,426.2v7.19a4,4,0,0,1-1.79,3.1L398.87,440c0-.21,0-.41,0-.63a16.53,16.53,0,0,1,7.47-12.95C406.48,426.35,406.64,426.28,406.8,426.2Z"
              style={{ fill: '#90CAF9', transformOrigin: '402.835px 433.1px' }}
              id="el0tsxk0f9mhr"
              className="animable"
            />
            <g id="el9dwmz4ue3s8">
              <g
                style={{ opacity: '0.15', transformOrigin: '373.265px 426.745px' }}
                className="animable"
                id="el57iguglkd3"
              >
                <path
                  d="M339.74,427.83l.06.05a21.75,21.75,0,0,0,8.5-14.72l-.07,0L341.52,417a4,4,0,0,0-1.79,3.1v7.72"
                  id="ell3wnxweervg"
                  className="animable"
                  style={{ transformOrigin: '344.015px 420.52px' }}
                />
                <path
                  d="M406.79,381.37V388c-4.1,2.34-7.43.41-7.43-4.34,0,0,0,0,0,0l5.63-3.26C406,379.77,406.79,380.23,406.79,381.37Z"
                  id="elrrbrrazr92l"
                  className="animable"
                  style={{ transformOrigin: '403.075px 384.555px' }}
                />
                <path
                  d="M341.54,473.13l5.72-3.29c0-4.73-3.36-6.64-7.47-4.27l0,0v6.51C339.75,473.24,340.55,473.7,341.54,473.13Z"
                  id="elarzby53ot8o"
                  className="animable"
                  style={{ transformOrigin: '343.524px 468.963px' }}
                />
                <path
                  d="M406.8,426.2v7.19a4,4,0,0,1-1.79,3.1L398.87,440c0-.21,0-.41,0-.63a16.53,16.53,0,0,1,7.47-12.95C406.48,426.35,406.64,426.28,406.8,426.2Z"
                  id="el6qgkjgzorpf"
                  className="animable"
                  style={{ transformOrigin: '402.835px 433.1px' }}
                />
              </g>
            </g>
            <path
              d="M348.23,413.13c-4.79-2.05-10.46-1.35-15.35.94l7.38,4.26a3.59,3.59,0,0,1,1.26-1.33Z"
              style={{ fill: '#90CAF9', transformOrigin: '340.555px 415.123px' }}
              id="elx7vr60ae1ka"
              className="animable"
            />
            <path
              d="M405,380.34l-5.67,3.28c-4.1-2.39-3.61-6,.5-8.34l5.18,3a3.92,3.92,0,0,1,1.78,3.1v.46h0v-.47C406.8,380.24,406,379.78,405,380.34Z"
              style={{ fill: '#90CAF9', transformOrigin: '401.64px 379.45px' }}
              id="el63e4vgvzvbx"
              className="animable"
            />
            <path
              d="M384.54,366.46l5.77,3.33a16.49,16.49,0,0,1-14.94,0l-.07,0,5.9-3.38A4,4,0,0,1,384.54,366.46Z"
              style={{ fill: '#90CAF9', transformOrigin: '382.805px 368.824px' }}
              id="elhbprneosu6c"
              className="animable"
            />
            <path
              d="M323.17,399.83c4.1,2.39,4.09,6.24,0,8.62h0l-6.93-4a3.75,3.75,0,0,1,1.27-1.32Z"
              style={{ fill: '#90CAF9', transformOrigin: '321.241px 404.14px' }}
              id="elh42y6djx9m"
              className="animable"
            />
            <g id="elcz6q69ywtam">
              <g
                style={{ opacity: '0.3', transformOrigin: '361.515px 392.2px' }}
                className="animable"
                id="elpedw7p6i1qm"
              >
                <path
                  d="M348.23,413.13c-4.79-2.05-10.46-1.35-15.35.94l7.38,4.26a3.59,3.59,0,0,1,1.26-1.33Z"
                  id="el2n2astrli2h"
                  className="animable"
                  style={{ transformOrigin: '340.555px 415.123px' }}
                />
                <path
                  d="M405,380.34l-5.67,3.28c-4.1-2.39-3.61-6,.5-8.34l5.18,3a3.92,3.92,0,0,1,1.78,3.1v.46h0v-.47C406.8,380.24,406,379.78,405,380.34Z"
                  id="el4iy9oemudlq"
                  className="animable"
                  style={{ transformOrigin: '401.64px 379.45px' }}
                />
                <path
                  d="M384.54,366.46l5.77,3.33a16.49,16.49,0,0,1-14.94,0l-.07,0,5.9-3.38A4,4,0,0,1,384.54,366.46Z"
                  id="el5wo0sie9ahn"
                  className="animable"
                  style={{ transformOrigin: '382.805px 368.824px' }}
                />
                <path
                  d="M323.17,399.83c4.1,2.39,4.09,6.24,0,8.62h0l-6.93-4a3.75,3.75,0,0,1,1.27-1.32Z"
                  id="elx1pn38sgqd"
                  className="animable"
                  style={{ transformOrigin: '321.241px 404.14px' }}
                />
              </g>
            </g>
            <path
              d="M340.26,418.33l-7.38-4.26c.48,5.39,2.7,10.64,6.86,13.76v-7.75A3.61,3.61,0,0,1,340.26,418.33Z"
              style={{ fill: '#90CAF9', transformOrigin: '336.57px 420.95px' }}
              id="el6kc6ne96u3j"
              className="animable"
            />
            <path
              d="M315.7,412.78V406.2a3.66,3.66,0,0,1,.51-1.76l6.94,4C323.15,413.2,319.81,415.14,315.7,412.78Z"
              style={{ fill: '#90CAF9', transformOrigin: '319.425px 409.112px' }}
              id="ely2993j6ndqo"
              className="animable"
            />
            <path
              d="M323.16,464.36a1.93,1.93,0,0,1,0,.24l-5.68-3.28a4,4,0,0,1-1.77-2.85l0-7.07h0A16.51,16.51,0,0,1,323.16,464.36Z"
              style={{ fill: '#90CAF9', transformOrigin: '319.437px 458px' }}
              id="eligob1s5b19"
              className="animable"
            />
            <path
              d="M339.76,472.11v-6.55c-4.12-2.36-7.45-.43-7.45,4.32l5.66,3.27a3.94,3.94,0,0,0,3.57,0h0C340.56,473.7,339.76,473.25,339.76,472.11Z"
              style={{ fill: '#90CAF9', transformOrigin: '336.925px 469.065px' }}
              id="ellpwjpqo54zm"
              className="animable"
            />
            <g id="el3p6fh1uw7rr">
              <g
                style={{ opacity: '0.45', transformOrigin: '328.62px 439.009px' }}
                className="animable"
                id="elhr9mtmkxg5d"
              >
                <path
                  d="M340.26,418.33l-7.38-4.26c.48,5.39,2.7,10.64,6.86,13.76v-7.75A3.61,3.61,0,0,1,340.26,418.33Z"
                  id="elba0wglazmme"
                  className="animable"
                  style={{ transformOrigin: '336.57px 420.95px' }}
                />
                <path
                  d="M315.7,412.78V406.2a3.66,3.66,0,0,1,.51-1.76l6.94,4C323.15,413.2,319.81,415.14,315.7,412.78Z"
                  id="el06indwqc2xu5"
                  className="animable"
                  style={{ transformOrigin: '319.425px 409.112px' }}
                />
                <path
                  d="M323.16,464.36a1.93,1.93,0,0,1,0,.24l-5.68-3.28a4,4,0,0,1-1.77-2.85l0-7.07h0A16.51,16.51,0,0,1,323.16,464.36Z"
                  id="eledv1m7xoah"
                  className="animable"
                  style={{ transformOrigin: '319.437px 458px' }}
                />
                <path
                  d="M339.76,472.11v-6.55c-4.12-2.36-7.45-.43-7.45,4.32l5.66,3.27a3.94,3.94,0,0,0,3.57,0h0C340.56,473.7,339.76,473.25,339.76,472.11Z"
                  id="elbxqzm8rottg"
                  className="animable"
                  style={{ transformOrigin: '336.925px 469.065px' }}
                />
              </g>
            </g>
            <path
              d="M348.75,403.13l-3.51,2a1.08,1.08,0,0,1-1,0l-5.75-3.32a1.06,1.06,0,0,1-.48-.83v-.36a1.06,1.06,0,0,1,.48-.83l3.52-2a1.06,1.06,0,0,1,.95,0l5.75,3.32a1,1,0,0,1,.48.83v.37A1,1,0,0,1,348.75,403.13Z"
              style={{ fill: '#90CAF9', transformOrigin: '343.6px 401.465px' }}
              id="elchso5vpuiw"
              className="animable"
            />
            <g id="el8tz112vpyai">
              <path
                d="M348.75,403.13l-3.51,2a1.08,1.08,0,0,1-1,0l-5.75-3.32a1.06,1.06,0,0,1-.48-.83v-.36a1.06,1.06,0,0,1,.48-.83l3.52-2a1.06,1.06,0,0,1,.95,0l5.75,3.32a1,1,0,0,1,.48.83v.37A1,1,0,0,1,348.75,403.13Z"
                style={{ opacity: '0.3', transformOrigin: '343.6px 401.465px' }}
                className="animable"
                id="ela04qq4ifcgv"
              />
            </g>
            <g id="el1ckvapjmryf">
              <path
                d="M338.43,399.89a1,1,0,0,0-.37.76V401a1.06,1.06,0,0,0,.48.83l5.75,3.32a1,1,0,0,0,.49.12v-1.47a1.09,1.09,0,0,1-.48-.11l-5.75-3.33C338.3,400.24,338.27,400.05,338.43,399.89Z"
                style={{ opacity: '0.1', transformOrigin: '341.42px 402.58px' }}
                className="animable"
                id="eluq7ey85wxy"
              />
            </g>
            <path
              d="M344.28,403.69l-5.75-3.32a.29.29,0,0,1,0-.55l3.52-2a1.06,1.06,0,0,1,.95,0l5.75,3.32c.27.15.27.4,0,.55l-3.51,2A1,1,0,0,1,344.28,403.69Z"
              style={{ fill: '#90CAF9', transformOrigin: '343.642px 400.76px' }}
              id="el4qjki86s68l"
              className="animable"
            />
            <g id="el5q7wfqra4fn">
              <path
                d="M344.28,403.69l-5.75-3.32a.29.29,0,0,1,0-.55l3.52-2a1.06,1.06,0,0,1,.95,0l5.75,3.32c.27.15.27.4,0,.55l-3.51,2A1,1,0,0,1,344.28,403.69Z"
                style={{ opacity: '0.2', transformOrigin: '343.642px 400.76px' }}
                className="animable"
                id="elvf3mtbne9rj"
              />
            </g>
            <path
              d="M384.52,382.48l-3.51,2a1,1,0,0,1-1,0l-5.75-3.32a1.06,1.06,0,0,1-.48-.82V380a1.06,1.06,0,0,1,.48-.83l3.52-2a1.06,1.06,0,0,1,.95,0l5.75,3.32a1.05,1.05,0,0,1,.48.83v.37A1,1,0,0,1,384.52,382.48Z"
              style={{ fill: '#90CAF9', transformOrigin: '379.37px 380.836px' }}
              id="elsb9cmq0nxxd"
              className="animable"
            />
            <g id="elhvcqqdx15h">
              <path
                d="M384.52,382.48l-3.51,2a1,1,0,0,1-1,0l-5.75-3.32a1.06,1.06,0,0,1-.48-.82V380a1.06,1.06,0,0,1,.48-.83l3.52-2a1.06,1.06,0,0,1,.95,0l5.75,3.32a1.05,1.05,0,0,1,.48.83v.37A1,1,0,0,1,384.52,382.48Z"
                style={{ opacity: '0.3', transformOrigin: '379.37px 380.836px' }}
                className="animable"
                id="elfaq8p4yi0i6"
              />
            </g>
            <g id="elfs46zj972ao">
              <path
                d="M374.2,379.25a1,1,0,0,0-.37.75v.37a1.06,1.06,0,0,0,.48.82l5.75,3.32a1,1,0,0,0,.48.12v-1.47h0a.91.91,0,0,1-.47-.12l-5.76-3.32C374.07,379.59,374,379.39,374.2,379.25Z"
                style={{ opacity: '0.1', transformOrigin: '377.185px 381.94px' }}
                className="animable"
                id="el3pxwpwasjxq"
              />
            </g>
            <path
              d="M380.05,383l-5.75-3.32a.29.29,0,0,1,0-.55l3.52-2a1.06,1.06,0,0,1,.95,0l5.75,3.32c.27.16.27.4,0,.55L381,383A1,1,0,0,1,380.05,383Z"
              style={{ fill: '#90CAF9', transformOrigin: '379.412px 380.069px' }}
              id="elj141ydxfcbp"
              className="animable"
            />
            <g id="el91e2kqqfdm">
              <path
                d="M380.05,383l-5.75-3.32a.29.29,0,0,1,0-.55l3.52-2a1.06,1.06,0,0,1,.95,0l5.75,3.32c.27.16.27.4,0,.55L381,383A1,1,0,0,1,380.05,383Z"
                style={{ opacity: '0.2', transformOrigin: '379.412px 380.069px' }}
                className="animable"
                id="elfffjieu2kfo"
              />
            </g>
            <path
              d="M351.13,392.69l-2.33-1.34a.7.7,0,0,0-.63,0l-3.81,2.19a.69.69,0,0,0-.32.55v.24a.68.68,0,0,0,.32.55l2.33,1.34a.7.7,0,0,0,.63,0l3.81-2.19a.71.71,0,0,0,.31-.55v-.24A.71.71,0,0,0,351.13,392.69Z"
              style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '347.74px 393.785px' }}
              id="elqdalwp65na"
              className="animable"
            />
            <path
              d="M348.14,391.33l-3.81,2.2a.19.19,0,0,0,0,.36l2.33,1.35a.7.7,0,0,0,.63,0l3.81-2.2a.2.2,0,0,0,0-.37l-2.33-1.34A.7.7,0,0,0,348.14,391.33Z"
              style={{ fill: 'rgb(55, 71, 79)', transformOrigin: '347.712px 393.285px' }}
              id="eletul9aaavng"
              className="animable"
            />
            <path
              d="M370.43,381.54l-2.33-1.35a.7.7,0,0,0-.63,0l-3.81,2.2a.71.71,0,0,0-.31.55v.24a.71.71,0,0,0,.31.55l2.33,1.34a.7.7,0,0,0,.63,0l3.81-2.2a.7.7,0,0,0,.32-.54v-.25A.7.7,0,0,0,370.43,381.54Z"
              style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '367.05px 382.63px' }}
              id="elxbkxb6bsdg"
              className="animable"
            />
            <path
              d="M367.44,380.18l-3.8,2.2c-.18.1-.18.26,0,.36l2.32,1.34a.64.64,0,0,0,.63,0l3.81-2.19a.19.19,0,0,0,0-.37l-2.33-1.34A.7.7,0,0,0,367.44,380.18Z"
              style={{ fill: 'rgb(55, 71, 79)', transformOrigin: '367.026px 382.134px' }}
              id="eld7mt7scszxr"
              className="animable"
            />
            <path
              d="M368.24,381.56l-2.25,1.3v-1.45h0v1.44l-1-.56v-1.44l-1.11-.64a3.14,3.14,0,0,0-2.86,0l-14.34,8.26a2.23,2.23,0,0,0-.32.25,1.37,1.37,0,0,0,.32.25l2.1,1.21v1.15h0v1.43l-2.24,1.3-1-.56v-1.45l-1.9-1.1a1.41,1.41,0,0,1-.79-1.08c0-.25,0-1.11,0-1.3,0-1,.94-2.17,2.68-3.18l12.12-7c2.63-1.52,6.05-2,7.64-1.09l2.88,1.67Z"
              style={{ fill: '#90CAF9', transformOrigin: '355.545px 385.45px' }}
              id="elr95mo78v1h"
              className="animable"
            />
            <g id="elbbl3xuxgau7">
              <path
                d="M368.24,381.56l-2.25,1.3v-1.45h0v1.44l-1-.56v-1.44l-1.11-.64a3.14,3.14,0,0,0-2.86,0l-14.34,8.26a2.23,2.23,0,0,0-.32.25,1.37,1.37,0,0,0,.32.25l2.1,1.21v1.15h0v1.43l-2.24,1.3-1-.56v-1.45l-1.9-1.1a1.41,1.41,0,0,1-.79-1.08c0-.25,0-1.11,0-1.3,0-1,.94-2.17,2.68-3.18l12.12-7c2.63-1.52,6.05-2,7.64-1.09l2.88,1.67Z"
                style={{ opacity: '0.4', transformOrigin: '355.545px 385.45px' }}
                className="animable"
                id="elk90elie79jn"
              />
            </g>
            <path
              d="M343.69,389.81c-1.59-.92-.74-2.89,1.89-4.41l12.12-7c2.63-1.52,6.05-2,7.64-1.09l2.88,1.67,0,2.57-2.25,1.3v-2.6l-2.09-1.2a3.17,3.17,0,0,0-2.86,0l-14.33,8.27a.87.87,0,0,0,0,1.65l2.1,1.21v2.59l-2.24,1.3v-2.6Z"
              style={{ fill: '#90CAF9', transformOrigin: '355.554px 385.46px' }}
              id="el0jhy0kpmy9vs"
              className="animable"
            />
            <g id="el17rvuwigamo">
              <path
                d="M343.69,389.81c-1.59-.92-.74-2.89,1.89-4.41l12.12-7c2.63-1.52,6.05-2,7.64-1.09l2.88,1.67,0,2.57-2.25,1.3v-2.6l-2.09-1.2a3.17,3.17,0,0,0-2.86,0l-14.33,8.27a.87.87,0,0,0,0,1.65l2.1,1.21v2.59l-2.24,1.3v-2.6Z"
                style={{ opacity: '0.2', transformOrigin: '355.554px 385.46px' }}
                className="animable"
                id="elfx1e4x632nl"
              />
            </g>
            <polygon
              points="368.24 381.56 365.99 382.85 365.99 380.26 368.22 378.99 368.24 381.56"
              style={{ fill: '#90CAF9', transformOrigin: '367.115px 380.92px' }}
              id="el1iqi7lbieeu"
              className="animable"
            />
            <g id="el0lsh99ogujz">
              <polygon
                points="368.24 381.56 365.99 382.85 365.99 380.26 368.22 378.99 368.24 381.56"
                style={{ opacity: '0.3', transformOrigin: '367.115px 380.92px' }}
                className="animable"
                id="elzn2dbdb9ivm"
              />
            </g>
            <polygon
              points="348.81 392.77 346.57 394.07 346.57 391.47 348.81 390.18 348.81 392.77"
              style={{ fill: '#90CAF9', transformOrigin: '347.69px 392.125px' }}
              id="elhw73qakkcym"
              className="animable"
            />
            <g id="elq1ge9973ouh">
              <polygon
                points="348.81 392.77 346.57 394.07 346.57 391.47 348.81 390.18 348.81 392.77"
                style={{ opacity: '0.3', transformOrigin: '347.69px 392.125px' }}
                className="animable"
                id="eloyl04q6cg7"
              />
            </g>
          </g>
          <g
            id="freepik--luggage--inject-2"
            className="animable"
            style={{ transformOrigin: '430.703px 366.756px' }}
          >
            <polygon
              points="437.98 335.43 437.98 273.31 440.15 272.06 440.15 334.17 437.98 335.43"
              style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '439.065px 303.745px' }}
              id="el6t2xfnojs1b"
              className="animable"
            />
            <polygon
              points="435.81 272.05 435.81 336.68 437.98 335.43 437.98 273.3 435.81 272.05"
              style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '436.895px 304.365px' }}
              id="elf50d8fi5woa"
              className="animable"
            />
            <polygon
              points="407.71 352.91 405.55 351.69 435.86 334.18 437.98 335.43 407.71 352.91"
              style={{ fill: 'rgb(55, 71, 79)', transformOrigin: '421.765px 343.545px' }}
              id="elt9z14qpw88"
              className="animable"
            />
            <polygon
              points="405.55 354.16 405.55 292.04 407.71 290.79 407.71 352.91 405.55 354.16"
              style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '406.63px 322.475px' }}
              id="elsqrs1rap5k8"
              className="animable"
            />
            <polygon
              points="403.38 290.79 403.38 355.42 405.55 354.16 405.55 292.04 403.38 290.79"
              style={{ fill: 'rgb(55, 71, 79)', transformOrigin: '404.465px 323.105px' }}
              id="eltnvqwxgv7lj"
              className="animable"
            />
            <path
              d="M437.43,269.44a1.67,1.67,0,0,0-1.71.17l-30,17.34a5,5,0,0,0-2.31,3.84v2.5l2.17,1.26,34.6-20,0-2.49a1.44,1.44,0,0,0-.56-1.31C439.22,270.46,437.8,269.67,437.43,269.44Z"
              style={{ fill: '#90CAF9', transformOrigin: '421.8px 281.915px' }}
              id="elucxbbfg5t7"
              className="animable"
            />
            <g id="eluht29p4obxf">
              <path
                d="M437.43,269.44a1.67,1.67,0,0,0-1.71.17l-30,17.34a5,5,0,0,0-2.31,3.84v2.5l2.17,1.26,34.6-20,0-2.49a1.44,1.44,0,0,0-.56-1.31C439.22,270.46,437.8,269.67,437.43,269.44Z"
                style={{
                  fill: 'rgb(255, 255, 255)',
                  opacity: '0.6',
                  transformOrigin: '421.8px 281.915px'
                }}
                className="animable"
                id="eliihxoieoqsm"
              />
            </g>
            <path
              d="M405.55,292a4.92,4.92,0,0,1,2.31-3.83l30-17.35c1.27-.73,2.3-.22,2.28,1.16l0,2.49-34.6,20Z"
              style={{ fill: '#90CAF9', transformOrigin: '422.84px 282.479px' }}
              id="el56tvj1ca3ea"
              className="animable"
            />
            <g id="elo1clz3hltxi">
              <path
                d="M405.55,292a4.92,4.92,0,0,1,2.31-3.83l30-17.35c1.27-.73,2.3-.22,2.28,1.16l0,2.49-34.6,20Z"
                style={{
                  fill: 'rgb(255, 255, 255)',
                  opacity: '0.3',
                  transformOrigin: '422.84px 282.479px'
                }}
                className="animable"
                id="el11olq3f7jmw"
              />
            </g>
            <g id="elja3gl2vjgn">
              <path
                d="M406.2,289.92a4.35,4.35,0,0,0-.65,2.12v2.51l-2.17-1.25v-2.51a4.26,4.26,0,0,1,.66-2.12Z"
                style={{ opacity: '0.1', transformOrigin: '404.79px 291.61px' }}
                className="animable"
                id="elvbrjctw1pwc"
              />
            </g>
            <path
              d="M423.52,463.93l0,0,0,0Z"
              style={{ fill: '#90CAF9', transformOrigin: '423.52px 463.93px' }}
              id="eldr304nj44oo"
              className="animable"
            />
            <path
              d="M470.66,352.88v82a2.63,2.63,0,0,1-1.11,2.44l-46,26.55a2.67,2.67,0,0,0,1.07-2.41v-82a11.85,11.85,0,0,0-5.35-9.26l-19.2-11.09a2.76,2.76,0,0,0-2.48-.35l45.83-26.48a2.63,2.63,0,0,1,2.68.25l19.21,11.09A11.87,11.87,0,0,1,470.66,352.88Z"
              style={{ fill: '#90CAF9', transformOrigin: '434.133px 397.947px' }}
              id="ellbey1vcsjpj"
              className="animable"
            />
            <g id="elnbey28pvu1">
              <path
                d="M470.66,352.88v82a2.63,2.63,0,0,1-1.11,2.44l-46,26.55a2.67,2.67,0,0,0,1.07-2.41v-82a11.85,11.85,0,0,0-5.35-9.26l-19.2-11.09a2.76,2.76,0,0,0-2.48-.35l45.83-26.48a2.63,2.63,0,0,1,2.68.25l19.21,11.09A11.87,11.87,0,0,1,470.66,352.88Z"
                style={{
                  fill: 'rgb(255, 255, 255)',
                  opacity: '0.3',
                  transformOrigin: '434.133px 397.947px'
                }}
                className="animable"
                id="el7krmhvd6idt"
              />
            </g>
            <g id="ellvyeb5dudkf">
              <path
                d="M423.52,463.93l0,0,0,0Z"
                style={{ opacity: '0.2', transformOrigin: '423.52px 463.93px' }}
                className="animable"
                id="el77q5f2esg1d"
              />
            </g>
            <path
              d="M400.07,451.68l20.78,12c2.08,1.2,3.78.21,3.78-2.18V379.45a11.86,11.86,0,0,0-5.35-9.25l-19.21-11.09c-2.07-1.2-3.77-.22-3.77,2.18v83.85A8.39,8.39,0,0,0,400.07,451.68Z"
              style={{ fill: '#90CAF9', transformOrigin: '410.465px 411.394px' }}
              id="elbaz8dm975a"
              className="animable"
            />
            <g id="elfb9mj7ru0uq">
              <path
                d="M400.07,451.68l20.78,12c2.08,1.2,3.78.21,3.78-2.18V379.45a11.86,11.86,0,0,0-5.35-9.25l-19.21-11.09c-2.07-1.2-3.77-.22-3.77,2.18v83.85A8.39,8.39,0,0,0,400.07,451.68Z"
                style={{ opacity: '0.15', transformOrigin: '410.465px 411.394px' }}
                className="animable"
                id="eljq9g4akr92d"
              />
            </g>
            <path
              d="M409,451.37a14.92,14.92,0,0,0-6.76-11.71c-2-1.13-3.72-1.18-5-.35h0l-4.56,2.6,9.7,16.48,4.52-2.6h0C408.2,455.09,409,453.57,409,451.37Z"
              style={{ fill: 'rgb(55, 71, 79)', transformOrigin: '400.84px 448.566px' }}
              id="eli8yf1ertb1"
              className="animable"
            />
            <path
              d="M397.5,442.38a15,15,0,0,1,6.76,11.72c0,4.31-3,6.06-6.76,3.9a14.93,14.93,0,0,1-6.77-11.71C390.73,442,393.76,440.23,397.5,442.38Z"
              style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '397.495px 450.195px' }}
              id="elrc9ajzba0fl"
              className="animable"
            />
            <path
              d="M397.5,447.22a5.69,5.69,0,0,1,2.57,4.46c0,1.64-1.15,2.31-2.57,1.49a5.68,5.68,0,0,1-2.58-4.46C394.92,447.06,396.07,446.4,397.5,447.22Z"
              style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '397.495px 450.194px' }}
              id="elkln1n1y0jmi"
              className="animable"
            />
            <path
              d="M417.54,461.77l3.66,2.14a2.34,2.34,0,0,0,2.37,0l5.9-3.4v-4.16a.85.85,0,0,0-1.27-.73l-3.58,2.06-5.8-3.35a.85.85,0,0,0-1.28.73Z"
              style={{ fill: 'rgb(55, 71, 79)', transformOrigin: '423.505px 459.223px' }}
              id="elwcscy1f4kdn"
              className="animable"
            />
            <path
              d="M424.63,461.5v-3.82h0l-5.8-3.35a.85.85,0,0,0-1.28.73v6.71h0l3.28,1.9a2.91,2.91,0,0,0,2.27.42,2.23,2.23,0,0,0,.4-.16A2.66,2.66,0,0,0,424.63,461.5Z"
              style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '421.096px 459.188px' }}
              id="elgg7quw6rhm"
              className="animable"
            />
            <path
              d="M469.55,437.36a2.64,2.64,0,0,0,1.11-2.44v-3.81h0l-3.78,2.18a2.15,2.15,0,0,0-1.07,1.86v4.38Z"
              style={{ fill: 'rgb(55, 71, 79)', transformOrigin: '468.242px 435.32px' }}
              id="el2usorl4zhsq"
              className="animable"
            />
            <g id="elrbyttjadpa9">
              <path
                d="M468.4,346.53l-46,26.58a10.21,10.21,0,0,0-3.08-2.91l-19.2-11.1a2.82,2.82,0,0,0-2.5-.34l45.86-26.49a2.65,2.65,0,0,1,2.66.26l19.22,11.09A10.45,10.45,0,0,1,468.4,346.53Z"
                style={{
                  fill: 'rgb(255, 255, 255)',
                  opacity: '0.4',
                  transformOrigin: '433.01px 352.569px'
                }}
                className="animable"
                id="elvjw68qe9i1c"
              />
            </g>
            <path
              d="M449.37,342.34a4.94,4.94,0,0,0-4.43,0l-2.22,1.28v.72l4.43,2.56,2.22-1.28a1.53,1.53,0,0,0,.91-1.28v-.72A1.55,1.55,0,0,0,449.37,342.34Z"
              style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '446.5px 344.358px' }}
              id="ele1fbc4chn5"
              className="animable"
            />
            <path
              d="M442.72,343.62l2.22-1.28a4.94,4.94,0,0,1,4.43,0,1.35,1.35,0,0,1,0,2.56l-2.22,1.28Z"
              style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '446.505px 343.998px' }}
              id="elfi15gbomkip"
              className="animable"
            />
            <polygon
              points="447.15 342.7 447.15 346.18 442.72 343.62 442.72 340.14 447.15 342.7"
              style={{ fill: 'rgb(55, 71, 79)', transformOrigin: '444.935px 343.16px' }}
              id="elik6f07wpr8"
              className="animable"
            />
            <polygon
              points="425 355.54 447.15 342.7 442.72 340.14 420.57 352.93 425 355.54"
              style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '433.86px 347.84px' }}
              id="el32tsldh8ufj"
              className="animable"
            />
            <polygon
              points="420.57 356.41 420.57 352.93 425 355.54 425 358.97 420.57 356.41"
              style={{ fill: 'rgb(55, 71, 79)', transformOrigin: '422.785px 355.95px' }}
              id="elixm5ckum2b"
              className="animable"
            />
            <path
              d="M425,359l-4.43-2.56-2.22,1.28a1.52,1.52,0,0,0-.9,1.27v.75a1.52,1.52,0,0,0,.9,1.27,4.94,4.94,0,0,0,4.43,0L425,359.7Z"
              style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '421.225px 358.987px' }}
              id="elayteae1le09"
              className="animable"
            />
            <path
              d="M420.57,356.41l-2.22,1.28a1.35,1.35,0,0,0,0,2.56,5,5,0,0,0,4.44,0L425,359Z"
              style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '421.215px 358.59px' }}
              id="elfxggzg0498n"
              className="animable"
            />
            <polygon
              points="425.72 355.11 425.72 359.28 424.99 359.7 424.99 355.53 425.72 355.11"
              style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '425.355px 357.405px' }}
              id="eljehexnxqy7"
              className="animable"
            />
            <polygon
              points="447.15 342.7 447.15 346.9 446.42 347.32 446.42 343.12 447.15 342.7"
              style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '446.785px 345.01px' }}
              id="elvbomtz1gu68"
              className="animable"
            />
            <polygon
              points="424.99 356.41 447.15 343.57 447.15 342.7 424.99 355.53 424.99 356.41"
              style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '436.07px 349.555px' }}
              id="el85qml5mde4r"
              className="animable"
            />
            <polygon
              points="446.42 347.32 446.42 344 443.56 345.66 446.42 347.32"
              style={{ fill: 'rgb(55, 71, 79)', transformOrigin: '444.99px 345.66px' }}
              id="elhbajt5u1x1"
              className="animable"
            />
          </g>
        </g>
        <g
          id="freepik--Airplane--inject-2"
          className="animable"
          style={{ transformOrigin: '204.563px 227.534px' }}
        >
          <g
            id="freepik--Trail--inject-2"
            className="animable"
            style={{ transformOrigin: '115.843px 227.534px' }}
          >
            <path
              d="M48.7,273.3c-27.08-16.1-32.58-41.72-32.58-41.72C15.34,187.28,47.56,140,84,116.25a201.5,201.5,0,0,0-37.33,94.2A204.16,204.16,0,0,0,48.7,273.3Z"
              style={{ fill: 'rgb(230, 230, 230)', transformOrigin: '50.0531px 194.775px' }}
              id="elskj14y7h2jj"
              className="animable"
            />
            <g id="elvm2ktc22lsd">
              <path
                d="M215.58,272.59c-39.67,43.59-95,73.9-146.32,64.52C31.47,323,17.38,276.41,16.12,231.58c0,0,8.34,38.86,55.05,50.93,57.26,14.8,117.57-16,117.57-16l23.16,4.7Z"
                style={{
                  fill: 'rgb(255, 255, 255)',
                  opacity: '0.5',
                  transformOrigin: '115.85px 285.199px'
                }}
                className="animable"
                id="el2cfdb1hl9r"
              />
            </g>
            <path
              d="M48.7,273.3a201.69,201.69,0,0,0,24.1,64.39c-1.18-.17-2.36-.36-3.54-.58C31.48,323,17.38,276.41,16.12,231.58,16.12,231.58,21.62,257.2,48.7,273.3Z"
              style={{ fill: 'rgb(240, 240, 240)', transformOrigin: '44.46px 284.635px' }}
              id="eljcefvjk311"
              className="animable"
            />
            <path
              d="M24.58,259.79s17.25,33.78,70.15,38.08,91.89-23.33,91.89-23.33-37.53,25.22-91.08,20.76C41.44,290.79,24.58,259.79,24.58,259.79Z"
              style={{ fill: 'rgb(250, 250, 250)', transformOrigin: '105.6px 279.057px' }}
              id="elfp8xn7je4gb"
              className="animable"
            />
            <path
              d="M165.14,292c-31.58,18.23-92.85,28-128.38,6.93,0,0,19.76,17,58.37,15C140.8,311.52,165.14,292,165.14,292Z"
              style={{ fill: 'rgb(250, 250, 250)', transformOrigin: '100.95px 303.047px' }}
              id="ellpvylrs4w9k"
              className="animable"
            />
            <path
              d="M197.75,281.66c-14.05,14.71-41.52,32.68-68.29,40.4s-56.64,8.63-72.14,0c0,0,26,10.3,72.14-2.57C172,307.62,197.75,281.66,197.75,281.66Z"
              style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '127.535px 304.928px' }}
              id="elwk4cjbd6u5"
              className="animable"
            />
          </g>
          <g
            id="freepik--Plane--inject-2"
            className="animable"
            style={{ transformOrigin: '272.3px 221.237px' }}
          >
            <g
              id="freepik--little-wing--inject-2"
              className="animable"
              style={{ transformOrigin: '225.986px 268.78px' }}
            >
              <path
                id="freepik--lttle-wing--inject-2"
                d="M243.73,274.75c2,1.7,2.37,3.77.89,4.62l-2.68,1.55-35.47-11.21,16.25-13.07Z"
                style={{ fill: 'rgb(235, 235, 235)', transformOrigin: '225.996px 268.78px' }}
                className="animable"
              />
              <path
                d="M231,272.92c2.76-.41,6.46-.92,9.11-1.28l-17.41-15-16.25,13.07,35.47,11.21S226.22,273.63,231,272.92Z"
                style={{ fill: 'rgb(224, 224, 224)', transformOrigin: '224.185px 268.78px' }}
                id="elr999oftxjcb"
                className="animable"
              />
              <path
                d="M241.94,280.92h0l2.68-1.55c1.48-.85,1.09-2.92-.89-4.62l-21-18.11s17.57,16.27,19.22,17.78S246.77,278.31,241.94,280.92Z"
                style={{ fill: 'rgb(250, 250, 250)', transformOrigin: '234.123px 268.78px' }}
                id="el0m9i6577xgge"
                className="animable"
              />
            </g>
            <g
              id="freepik--Wing--inject-2"
              className="animable"
              style={{ transformOrigin: '334.352px 237.583px' }}
            >
              <g
                id="freepik--wing--inject-2"
                className="animable"
                style={{ transformOrigin: '334.352px 237.583px' }}
              >
                <path
                  id="freepik--wing--inject-2"
                  d="M377.7,255l-53.15-43.08-.11-.08c-1.59-.92-8.36,1.51-15.12,5.41l-10,5.76c-6.76,3.9-11,7.81-9.37,8.73l.13.06,81.57,31.77,5.61-3.24C379.54,259,379.72,256.59,377.7,255Z"
                  style={{ fill: 'rgb(235, 235, 235)', transformOrigin: '334.351px 237.608px' }}
                  className="animable"
                />
                <path
                  d="M318.65,232.21l18.1-10.45-12.2-9.89-.11-.08c-1.59-.92-8.36,1.51-15.12,5.41l-10,5.76c-6.76,3.9-11,7.81-9.37,8.73l.13.06,81.57,31.77L318.78,236.7C316.45,235.52,316.4,233.51,318.65,232.21Z"
                  style={{ fill: 'rgb(224, 224, 224)', transformOrigin: '330.626px 237.558px' }}
                  id="elqw93f2a76e"
                  className="animable"
                />
                <path
                  d="M376.06,261h0l1.22-.7c2.26-1.3,2.44-3.69.42-5.33l-53.15-43.08s47.12,39.37,49.56,41.89S380.45,258.45,376.06,261Z"
                  style={{ fill: 'rgb(250, 250, 250)', transformOrigin: '351.826px 236.445px' }}
                  id="el05dpes6azebq"
                  className="animable"
                />
              </g>
              <path
                d="M328.69,234.62a101.74,101.74,0,0,0-13.33,6.4s-.21.79.89,1.42a4.67,4.67,0,0,0,2.47.51,75,75,0,0,0,10.59-7.29A.61.61,0,0,0,328.69,234.62Z"
                style={{ fill: '#90CAF9', transformOrigin: '322.445px 238.765px' }}
                id="el8ivf2ek1fl"
                className="animable"
              />
              <path
                d="M328.69,234.62a101.74,101.74,0,0,0-13.33,6.4s-.21.79.89,1.42a4.67,4.67,0,0,0,2.47.51,75,75,0,0,0,10.59-7.29A.61.61,0,0,0,328.69,234.62Z"
                style={{ fill: '#90CAF9', transformOrigin: '322.445px 238.765px' }}
                id="el4f5b22ldblo"
                className="animable"
              />
              <path
                d="M328.69,234.62a101.74,101.74,0,0,0-13.33,6.4s-.21.79.89,1.42a4.67,4.67,0,0,0,2.47.51,75,75,0,0,0,10.59-7.29A.61.61,0,0,0,328.69,234.62Z"
                style={{ fill: '#90CAF9', transformOrigin: '322.445px 238.765px' }}
                id="el0gg32e1tzoco"
                className="animable"
              />
              <path
                d="M328.69,234.62a101.74,101.74,0,0,0-13.33,6.4s-.21.79.89,1.42a4.67,4.67,0,0,0,2.47.51,75,75,0,0,0,10.59-7.29A.61.61,0,0,0,328.69,234.62Z"
                style={{ fill: '#90CAF9', transformOrigin: '322.445px 238.765px' }}
                id="elhd36l8qz6v"
                className="animable"
              />
              <path
                d="M328.69,234.62a101.74,101.74,0,0,0-13.33,6.4s-.21.79.89,1.42a4.67,4.67,0,0,0,2.47.51,75,75,0,0,0,10.59-7.29A.61.61,0,0,0,328.69,234.62Z"
                style={{ fill: '#90CAF9', transformOrigin: '322.445px 238.765px' }}
                id="elxhq7rj1c7ph"
                className="animable"
              />
              <g id="elr8c6nktnxt">
                <path
                  d="M328.69,234.62a101.74,101.74,0,0,0-13.33,6.4s-.21.79.89,1.42a4.67,4.67,0,0,0,2.47.51,75,75,0,0,0,10.59-7.29A.61.61,0,0,0,328.69,234.62Z"
                  style={{ opacity: '0.15', transformOrigin: '322.445px 238.765px' }}
                  className="animable"
                  id="elhocyp2061pj"
                />
              </g>
              <g id="elzo020xdigi">
                <path
                  d="M317.72,240.91c.79-.95,10.93-6.27,11.7-6.08a.59.59,0,0,0-.73-.21,101.74,101.74,0,0,0-13.33,6.4s-.21.79.89,1.42a4.67,4.67,0,0,0,2.47.51C317.81,242.66,316.92,241.86,317.72,240.91Z"
                  style={{ opacity: '0.15', transformOrigin: '322.382px 238.765px' }}
                  className="animable"
                  id="elu9qjg1az7rs"
                />
              </g>
              <path
                d="M344.41,243.36a78.29,78.29,0,0,0-10.42,5s-.17.62.69,1.12a3.7,3.7,0,0,0,1.94.4,59,59,0,0,0,8.29-5.7A.49.49,0,0,0,344.41,243.36Z"
                style={{ fill: '#90CAF9', transformOrigin: '339.522px 246.61px' }}
                id="eljwfv6htv9fk"
                className="animable"
              />
              <g id="eldpmrrqjlrn">
                <path
                  d="M344.41,243.36a78.29,78.29,0,0,0-10.42,5s-.17.62.69,1.12a3.7,3.7,0,0,0,1.94.4,59,59,0,0,0,8.29-5.7A.49.49,0,0,0,344.41,243.36Z"
                  style={{ opacity: '0.15', transformOrigin: '339.522px 246.61px' }}
                  className="animable"
                  id="eleyo6xxo5pe9"
                />
              </g>
              <g id="el76m170hif0e">
                <path
                  d="M335.83,248.28a31.57,31.57,0,0,1,5.34-3.05c2.8-1.44,3.72-1.82,3.92-1.38a.49.49,0,0,0-.68-.49,78.29,78.29,0,0,0-10.42,5s-.17.62.69,1.12a3.7,3.7,0,0,0,1.94.4S335.17,248.94,335.83,248.28Z"
                  style={{ opacity: '0.15', transformOrigin: '339.534px 246.605px' }}
                  className="animable"
                  id="elfk9ibhrtvjd"
                />
              </g>
              <path
                d="M360.51,252.73a.37.37,0,0,0-.37-.63,57.56,57.56,0,0,0-7.53,3.62s-.12.45.51.82a2.72,2.72,0,0,0,1.41.29A42.51,42.51,0,0,0,360.51,252.73Z"
                style={{ fill: '#90CAF9', transformOrigin: '356.623px 254.455px' }}
                id="el4y79kkmfbom"
                className="animable"
              />
              <g id="eln4o12opur1">
                <path
                  d="M360.51,252.73a.37.37,0,0,0-.37-.63,57.56,57.56,0,0,0-7.53,3.62s-.12.45.51.82a2.72,2.72,0,0,0,1.41.29A42.51,42.51,0,0,0,360.51,252.73Z"
                  style={{ opacity: '0.15', transformOrigin: '356.623px 254.455px' }}
                  className="animable"
                  id="ely2ikmiz0tg"
                />
              </g>
              <g id="elpv3nge72nmq">
                <path
                  d="M353.84,255.71a27.6,27.6,0,0,1,4.77-2.6c1.83-.81,2-.88,2-.67a.36.36,0,0,0-.5-.34,57.56,57.56,0,0,0-7.53,3.62s-.12.45.51.82a2.72,2.72,0,0,0,1.41.29C354,256.62,353.41,256.14,353.84,255.71Z"
                  style={{ opacity: '0.15', transformOrigin: '356.59px 254.454px' }}
                  className="animable"
                  id="elxurssqz61af"
                />
              </g>
            </g>
            <g
              id="freepik--Tail--inject-2"
              className="animable"
              style={{ transformOrigin: '212.825px 235.878px' }}
            >
              <path
                id="freepik--tail--inject-2"
                d="M232,246.86l-29.41-35.15c-1.67-2-4.34-2.86-6-1.92l-2.94,1.69,11.49,50.86Z"
                style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '212.825px 235.875px' }}
                className="animable"
              />
              <path
                d="M232,246.86l-5.88-7c-2.57,1.62-12.25,7.33-17.84,5.26-6.49-2.41-13.1-27.06-13.1-27.06h0l10,44.3Z"
                style={{ fill: 'rgb(224, 224, 224)', transformOrigin: '213.59px 240.21px' }}
                id="elckrnoky5wy6"
                className="animable"
              />
              <path
                d="M207.75,260.79l24.24-14c-9.05,2-15.41.15-20.75-5-6.74-6.47-17.56-30.41-17.56-30.41l11.3,50Z"
                style={{ fill: '#90CAF9', transformOrigin: '212.835px 236.38px' }}
                id="eliy2fa14i7u"
                className="animable"
              />
              <g id="el4pmhqsc3nml">
                <path
                  d="M232,246.82h0c-6.88,1.48-12.2.77-16.7-1.91-2.5.68-5,.93-7,.2-6.05-2.24-12.21-23.83-13-26.73L205,261.43l2.77-.64Z"
                  style={{ opacity: '0.1', transformOrigin: '213.65px 239.905px' }}
                  className="animable"
                  id="el7x7b4v8wta4"
                />
              </g>
              <path
                d="M202.06,213.58c-1.74-1.94-4.32-3.21-5.77-2.84l-2.61.67,2.94-1.66c1.62-.91,4.29,0,6,2L232,246.8Z"
                style={{ fill: 'rgb(255, 255, 255)', transformOrigin: '212.84px 228.098px' }}
                id="el9p3egj9ds18"
                className="animable"
              />
            </g>
            <g
              id="freepik--Turbine--inject-2"
              className="animable"
              style={{ transformOrigin: '330.76px 226.57px' }}
            >
              <path
                d="M328.14,232.82a6.31,6.31,0,1,1-6.3-6.3A6.3,6.3,0,0,1,328.14,232.82Z"
                style={{ fill: 'rgb(224, 224, 224)', transformOrigin: '321.83px 232.83px' }}
                id="el51kkgoarw5k"
                className="animable"
              />
              <g id="elimk0qy5bks">
                <path
                  d="M328.14,232.82a6.31,6.31,0,1,1-6.3-6.3A6.3,6.3,0,0,1,328.14,232.82Z"
                  style={{ opacity: '0.1', transformOrigin: '321.83px 232.83px' }}
                  className="animable"
                  id="elv8vma8lljwm"
                />
              </g>
              <g id="elf1cc98fgha">
                <path
                  d="M328.14,232.82a6.31,6.31,0,0,0-9.81-5.24,10.67,10.67,0,0,0,2.6,9.59c.45.44-2.58.42-5-2.18a6.3,6.3,0,0,0,12.22-2.17Z"
                  style={{ opacity: '0.1', transformOrigin: '322.04px 232.828px' }}
                  className="animable"
                  id="elc7q7ats3dw"
                />
              </g>
              <path
                d="M336.33,214c-6.1,0-16.5,10.26-17.07,11h0a4.74,4.74,0,0,0-.93,3.07,12.72,12.72,0,0,0,5.75,10,4.57,4.57,0,0,0,3.27.71h0c.91-.13,14.93-4.11,18-9.39Z"
                style={{ fill: 'rgb(224, 224, 224)', transformOrigin: '331.837px 226.42px' }}
                id="el4c0x96b3wzx"
                className="animable"
              />
              <g id="elv72uywy2blr">
                <path
                  d="M345.33,229.34l-8.58-14.61c-1.63.17-3,.52-3.37,1.19-1.28,2.1-1.42,6.14,0,9.19s1.34,4.1-4.86,6.09-7.8,1.72-9.93-1a12.81,12.81,0,0,0,5.49,7.87,4.57,4.57,0,0,0,3.27.71h0C328.26,238.6,342.28,234.62,345.33,229.34Z"
                  style={{ opacity: '0.1', transformOrigin: '331.96px 226.785px' }}
                  className="animable"
                  id="elf0ibnjmm3td"
                />
              </g>
              <path
                d="M336.33,214c-6.1,0-16.5,10.26-17.07,11h0a4.38,4.38,0,0,0-.88,2.46c.39-1.49,2.05-2.9,4.23-4.76A92.66,92.66,0,0,1,332,216c1.18-.57-.08,2.42,1.27,5.69l3.53-7Z"
                style={{ fill: 'rgb(250, 250, 250)', transformOrigin: '327.59px 220.73px' }}
                id="el3rjkwcfz0yi"
                className="animable"
              />
              <path
                d="M346,226.36c0,4.21-3,5.92-6.61,3.81a14.59,14.59,0,0,1-6.61-11.44c0-4.22,3-5.92,6.61-3.82A14.61,14.61,0,0,1,346,226.36Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '339.39px 222.542px' }}
                id="elsv40pgd4t5l"
                className="animable"
              />
              <g id="elskww7qhhr5">
                <path
                  d="M339.09,222.54l3.15-3.45-3.73,3.73Zm-.41-.43,2.15-4.15-2.63,4.57Zm-.5-.31,1-4.58-1.39,5.11Zm-.57-.17-.18-4.69,0,5.29Zm5.7-1.08-4.57,2.63.63-.11ZM338.05,226l2.54,4-2.65-4.63Zm5.91-3.77-5.09,1.36.64,0Zm-5.38,3.49,3.47,3.18-3.75-3.76ZM337,221.61l-1.37-4.48,1.32,5.12Zm2.47,2.63,4.67-.21h-5.27Zm-.48,1.07,4.15,2.15-4.57-2.63Zm.31-.51,4.57,1-5.1-1.37Zm-3.92-.28-.17.26.8-.47Zm.9,1.32,0,.67.49-1.55Zm-.65-.87-.13.32.58-.58Zm.3.42-.07.44.54-1Zm1.53.74.88,2.61-.83-3.24Zm-.63-.08.21,1.39,0-2.37Zm-1.36-3.61-1.64-.78,2,1.26Zm-.53,1.81L336,224h-.7Zm1.48-2.62-2.52-3.94,2.64,4.69Zm-.52.4-2.41-2.2,2.68,2.78Zm-.47,1-.17-.1-1-.07,1.41.46Zm.12.57-.24-.07-.69.13,1,.08Z"
                  style={{
                    fill: 'rgb(255, 255, 255)',
                    opacity: '0.5',
                    transformOrigin: '338.815px 223.47px'
                  }}
                  className="animable"
                  id="el0waxv5bxa4zr"
                />
              </g>
              <path
                d="M338.26,225.11l5.13,5.13a.29.29,0,0,0,.29.07l.16-.08,0,0s0-.07-.12-.15l-5.22-5.22c-.07-.07-.06-.09,0,0l6.44,3.71a.16.16,0,0,0,.23-.08h0a.22.22,0,0,0-.1-.27l-6.38-3.68c-.09,0-.08-.07,0,0l6.58,1.77c.11,0,.18,0,.17-.14v0a.28.28,0,0,0-.2-.24l-6.45-1.73c-.1,0-.1,0,0,0H345a.14.14,0,0,0,.14-.18h0a.26.26,0,0,0-.23-.19h-6.08c-.11,0-.11,0,0,0l5.56-1.49a.16.16,0,0,0,.12-.22h0a.21.21,0,0,0-.25-.12l-5.53,1.48c-.1,0-.11,0,0,0l4.86-2.8c.09,0,.14-.14.12-.2l-.06-.1,0-.06s-.11,0-.2,0l-4.86,2.81c-.09,0-.11,0,0,0l4.05-4.06a.23.23,0,0,0,0-.28h0a.16.16,0,0,0-.25,0l-4.08,4.08c-.08.08-.09.06,0,0l3-5.29a.24.24,0,0,0,0-.29h0a.14.14,0,0,0-.23,0l-3.1,5.36c-.05.09-.07.09,0,0l1.73-6.48a.29.29,0,0,0-.1-.29l0,0a.13.13,0,0,0-.21.08l-1.77,6.62c0,.1-.05.09-.05,0v-7.42a.23.23,0,0,0-.18-.22h0a.15.15,0,0,0-.18.16v7.48c0,.1,0,.11-.05,0L335.08,215a.41.41,0,0,0-.08-.17l0,0-.13.09a.28.28,0,0,0-.09.28l1.9,7.08c0,.1,0,.11,0,0l-3-5.22c-.05-.09-.11-.08-.14,0s0,.12,0,.18a.61.61,0,0,0,.06.35l2.81,4.86c.05.09,0,.1,0,0l-2.76-2.76c-.07-.07-.12,0-.12.06s0,.13,0,.2a.53.53,0,0,0,.15.32l2.45,2.45c.07.07.06.09,0,0l-2.09-1.2c-.09-.06-.14,0-.11.08l.05.17a.53.53,0,0,0,.22.27l1.74,1c.09.06.08.08,0,0l-1.44-.39c-.1,0-.15,0-.12.13l0,.08a.41.41,0,0,0,.25.23l1.18.31c.1,0,.1,0,0,0h-1c-.11,0-.16.08-.11.17l0,0a.35.35,0,0,0,.28.17h.79c.11,0,.11,0,0,0l-.67.18a.15.15,0,0,0-.1.22h0a.23.23,0,0,0,.27.12l.59-.16c.1,0,.11,0,0,0l-.52.3c-.09.05-.15.12-.13.16l0,.06.06.1c0,.05.13.05.22,0l.51-.29c.09-.06.11,0,0,0l-.43.42a.27.27,0,0,0,0,.3h0a.15.15,0,0,0,.24,0l.48-.49c.08-.07.09-.06,0,0l-.39.69a.33.33,0,0,0,0,.32l0,0c0,.08.14.08.2,0l.49-.85c0-.09.07-.08,0,0l-.31,1.16a.38.38,0,0,0,.07.33l.06.07c.06.08.14.06.17,0l.38-1.42c0-.1.05-.1.05,0v2a.53.53,0,0,0,.12.32l.12.12c.07.07.13.05.13,0v-2.38c0-.1,0-.1.05,0l.88,3.29a.66.66,0,0,0,.2.29l.18.11c.08.06.13,0,.1-.07l-1-3.72c0-.1,0-.11,0,0l2.77,4.8a.6.6,0,0,0,.28.22l.17.06c.1,0,.14,0,.08-.12l-3-5.15C338.17,225.05,338.18,225,338.26,225.11Z"
                style={{ fill: 'rgb(55, 71, 79)', transformOrigin: '339.484px 222.577px' }}
                id="el5hjzljcpxhu"
                className="animable"
              />
              <path
                d="M341.28,221.5a.67.67,0,0,0-.42-.3h0s-3.36-.72-4.94.19a1.41,1.41,0,0,0-.57,1.28,4.34,4.34,0,0,0,2,3.41,1.4,1.4,0,0,0,1.39.14h0c1.58-.92,2.63-4.19,2.63-4.19h0A.68.68,0,0,0,341.28,221.5Z"
                style={{ fill: 'rgb(235, 235, 235)', transformOrigin: '338.366px 223.636px' }}
                id="elwtwu8lhaie8"
                className="animable"
              />
              <g id="elqa408yh864s">
                <path
                  d="M338.53,224.23c-1.28.82-2.26-.16-2.56-1.18a1.5,1.5,0,0,1,.75-2,2.9,2.9,0,0,0-.81.31,1.38,1.38,0,0,0-.57,1.27,4.34,4.34,0,0,0,2,3.41,1.4,1.4,0,0,0,1.39.14h0c1.58-.91,2.63-4.19,2.63-4.19h0a.68.68,0,0,0-.05-.52C341.33,222,339.81,223.41,338.53,224.23Z"
                  style={{ opacity: '0.1', transformOrigin: '338.361px 223.676px' }}
                  className="animable"
                  id="elc80m8bj97ir"
                />
              </g>
              <path
                d="M341.33,222a.68.68,0,0,0-.05-.52.67.67,0,0,0-.42-.3h0s-3.36-.72-4.94.19a1.18,1.18,0,0,0-.48.67c.22-.41.86-.78,2.49-.83a11.1,11.1,0,0,1,3,.22.36.36,0,0,0-.1.43c.1.27.42.36.55.15Z"
                style={{ fill: 'rgb(250, 250, 250)', transformOrigin: '338.41px 221.518px' }}
                id="el4d6m0ph0gso"
                className="animable"
              />
            </g>
            <g
              id="freepik--Body--inject-2"
              className="animable"
              style={{ transformOrigin: '291.955px 218.638px' }}
            >
              <path
                id="freepik--body--inject-2"
                d="M382.23,165.54S379,161,372,161.61s-13.6,3.43-25.09,10.07l-72.77,42c-11.49,6.64-42.75,24.68-53.63,33.17S193.68,269,193.68,269h0a6.1,6.1,0,0,0-2.75,4.77c0,1.25.63,2,1.54,1.95v0h.14c1.5-.08,14.81-.87,36.14-4.86,22.67-4.24,31.61-9.41,45.37-17.35L373.7,196c9.19-5.3,17.9-14.75,19.15-22.11S388.26,165.48,382.23,165.54Z"
                style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '291.975px 218.638px' }}
                className="animable"
              />
              <path
                d="M361.24,170.15c-4.8,5.11-6.69,10.37-14.35,14.8-7.32,4.22-97.26,53.6-113.37,61.91s-20,9-17.94,3.91h0C205.39,259,193.68,269,193.68,269h0a6.1,6.1,0,0,0-2.75,4.77c0,1.25.63,2,1.54,1.95v0h.14c1.5-.08,14.81-.87,36.14-4.86,22.67-4.24,31.61-9.41,45.37-17.35L373.7,196c9.19-5.3,17.9-14.75,19.15-22.11s-4.59-8.41-10.62-8.35C377.9,164.63,366,165,361.24,170.15Z"
                style={{ fill: '#90CAF9', transformOrigin: '291.975px 220.437px' }}
                id="els348nmpb2m"
                className="animable"
              />
              <g id="elfbetcru9g8h">
                <path
                  d="M361.24,170.15c-4.8,5.11-6.69,10.37-14.35,14.8-7.32,4.22-97.26,53.6-113.37,61.91s-20,9-17.94,3.91h0C205.39,259,193.68,269,193.68,269h0a6.1,6.1,0,0,0-2.75,4.77c0,1.25.63,2,1.54,1.95v0h.14c1.5-.08,14.81-.87,36.14-4.86,22.67-4.24,31.61-9.41,45.37-17.35L373.7,196c9.19-5.3,17.9-14.75,19.15-22.11s-4.59-8.41-10.62-8.35C377.9,164.63,366,165,361.24,170.15Z"
                  style={{
                    fill: 'rgb(255, 255, 255)',
                    opacity: '0.4',
                    transformOrigin: '291.975px 220.437px'
                  }}
                  className="animable"
                  id="el8jvo4d26fvk"
                />
              </g>
              <g id="el9t2f2p6t0vl">
                <path
                  d="M389,168.12c3.58,1.69,4.18,4.51,3.46,7.32a11.22,11.22,0,0,0,.37-1.55c1.26-7.36-4.59-8.41-10.62-8.35-4.33-.91-16.19-.5-21,4.61C372.59,166.14,385,166.23,389,168.12Z"
                  style={{
                    fill: 'rgb(250, 250, 250)',
                    opacity: '0.5',
                    transformOrigin: '377.106px 170.299px'
                  }}
                  className="animable"
                  id="elox03580rei"
                />
              </g>
              <g id="elcv2mdj5uo2o">
                <path
                  d="M369.87,182.05c-14.34,7.41-45,24.75-73.46,40.74l3.83-11-33.67,18.6-3.94,11.26c-7.75,4.29-14.37,7.89-19.16,10.38a282,282,0,0,1-31.31,13.6l3.42-9.78-17,11.26-1.27,3.64c-2,.63-3.29,1-3.67,1.09-1,.21-1.22-.8-.8-2.29a6.2,6.2,0,0,0-1.95,4.16c0,1.25.63,2,1.54,1.95v0h.14c1.5-.08,14.81-.87,36.14-4.86,22.67-4.24,31.61-9.41,45.37-17.35L373.7,196a51.44,51.44,0,0,0,13.5-11.4C391.44,177.11,392,170.63,369.87,182.05Z"
                  style={{ opacity: '0.1', transformOrigin: '290.204px 225.758px' }}
                  className="animable"
                  id="elrjuav4038m8"
                />
              </g>
            </g>
            <g
              id="freepik--Windows--inject-2"
              className="animable"
              style={{ transformOrigin: '284.734px 210.989px' }}
            >
              <path
                d="M285.46,211.09a8.9,8.9,0,0,1,.26-2.21c.06-.25-.05-.35-.28-.22l-.9.52a1.34,1.34,0,0,0-.55.69,8.72,8.72,0,0,0-.26,2.22.26.26,0,0,0,.42.23l.91-.52A.91.91,0,0,0,285.46,211.09Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '284.732px 210.49px' }}
                id="elznb5mmg5qgb"
                className="animable"
              />
              <path
                d="M288.69,209.23a9.5,9.5,0,0,1,.25-2.22c.07-.25-.05-.34-.27-.21l-.91.52a1.33,1.33,0,0,0-.54.69,8.22,8.22,0,0,0-.26,2.21.26.26,0,0,0,.42.24l.91-.52A.91.91,0,0,0,288.69,209.23Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '287.959px 208.629px' }}
                id="ele1cp8r2ek5i"
                className="animable"
              />
              <path
                d="M291.92,207.37a8.94,8.94,0,0,1,.25-2.22c.07-.25-.05-.35-.27-.22l-.91.53a1.34,1.34,0,0,0-.54.68,7.91,7.91,0,0,0-.26,2.22c0,.26.2.36.42.23l.91-.52A.9.9,0,0,0,291.92,207.37Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '291.189px 206.76px' }}
                id="el9zp8jzm3tw6"
                className="animable"
              />
              <path
                d="M295.15,205.5a8.42,8.42,0,0,1,.25-2.21c.07-.26,0-.35-.27-.22l-.91.52a1.37,1.37,0,0,0-.54.69,7.91,7.91,0,0,0-.26,2.22c0,.26.19.36.42.23l.9-.52A.9.9,0,0,0,295.15,205.5Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '294.421px 204.899px' }}
                id="elghvp5luedir"
                className="animable"
              />
              <path
                d="M298.38,203.64a8.49,8.49,0,0,1,.25-2.22c.06-.25-.05-.35-.28-.22l-.9.53a1.25,1.25,0,0,0-.54.68,7.91,7.91,0,0,0-.26,2.22c0,.26.19.37.42.24l.9-.53A.88.88,0,0,0,298.38,203.64Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '297.647px 203.034px' }}
                id="el4svpx1rqi1r"
                className="animable"
              />
              <path
                d="M301.61,201.77a8.42,8.42,0,0,1,.25-2.21c.06-.25-.05-.35-.28-.22l-.9.52a1.27,1.27,0,0,0-.54.69,8.32,8.32,0,0,0-.27,2.22c0,.26.2.36.43.23l.9-.52A.9.9,0,0,0,301.61,201.77Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '300.873px 201.17px' }}
                id="elj3c09abptko"
                className="animable"
              />
              <path
                d="M304.83,199.91a9,9,0,0,1,.26-2.22c.06-.25,0-.34-.28-.21l-.9.52a1.3,1.3,0,0,0-.55.69,8.64,8.64,0,0,0-.26,2.21c0,.26.2.37.42.24l.91-.52A.91.91,0,0,0,304.83,199.91Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '304.105px 199.308px' }}
                id="el9ocj5zgxmkb"
                className="animable"
              />
              <path
                d="M308.06,198.05a9.44,9.44,0,0,1,.25-2.22c.07-.25-.05-.35-.27-.22l-.91.53a1.34,1.34,0,0,0-.54.68,8.29,8.29,0,0,0-.26,2.22c0,.26.2.36.42.23l.91-.52A.9.9,0,0,0,308.06,198.05Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '307.329px 197.44px' }}
                id="eldr0ubeph4a"
                className="animable"
              />
              <path
                d="M311.29,196.18a8.86,8.86,0,0,1,.25-2.21c.07-.26-.05-.35-.27-.22l-.91.52a1.37,1.37,0,0,0-.54.69,7.91,7.91,0,0,0-.26,2.22c0,.26.2.36.42.23l.91-.52A.91.91,0,0,0,311.29,196.18Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '310.559px 195.579px' }}
                id="el1pjl6y3lrzn"
                className="animable"
              />
              <path
                d="M314.52,194.32a8.49,8.49,0,0,1,.25-2.22c.07-.25,0-.34-.27-.21l-.91.52a1.34,1.34,0,0,0-.54.68,7.91,7.91,0,0,0-.26,2.22c0,.26.19.37.42.24l.9-.53A.88.88,0,0,0,314.52,194.32Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '313.791px 193.718px' }}
                id="elzdsauhn9u7"
                className="animable"
              />
              <path
                d="M317.75,192.45a8.42,8.42,0,0,1,.25-2.21c.06-.25-.05-.35-.28-.22l-.9.52a1.27,1.27,0,0,0-.54.69,7.91,7.91,0,0,0-.26,2.22c0,.26.19.36.42.23l.9-.52A.9.9,0,0,0,317.75,192.45Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '317.017px 191.85px' }}
                id="elodtbli5gjae"
                className="animable"
              />
              <path
                d="M321,190.59a8.54,8.54,0,0,1,.25-2.22c.06-.25-.05-.34-.28-.21l-.9.52a1.24,1.24,0,0,0-.54.69,7.84,7.84,0,0,0-.26,2.21c0,.26.19.37.42.24l.9-.52A.9.9,0,0,0,321,190.59Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '320.267px 189.988px' }}
                id="elboctng0wl2"
                className="animable"
              />
              <path
                d="M324.2,188.73a9,9,0,0,1,.26-2.22c.06-.25,0-.35-.28-.22l-.9.53a1.31,1.31,0,0,0-.55.68,8.72,8.72,0,0,0-.26,2.22c0,.26.2.36.43.23l.9-.52A.9.9,0,0,0,324.2,188.73Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '323.475px 188.12px' }}
                id="elabsqesmngpu"
                className="animable"
              />
              <path
                d="M327.43,186.86a9.36,9.36,0,0,1,.25-2.21c.07-.26-.05-.35-.27-.22l-.91.52a1.37,1.37,0,0,0-.54.69,8.72,8.72,0,0,0-.26,2.22c0,.26.2.36.42.23l.91-.52A.91.91,0,0,0,327.43,186.86Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '326.7px 186.259px' }}
                id="ellslrz9oiia7"
                className="animable"
              />
              <path
                d="M330.66,185a8.94,8.94,0,0,1,.25-2.22c.07-.25-.05-.34-.27-.21l-.91.52a1.34,1.34,0,0,0-.54.68,7.91,7.91,0,0,0-.26,2.22.26.26,0,0,0,.42.24l.91-.53A.9.9,0,0,0,330.66,185Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '329.929px 184.399px' }}
                id="eldx3otbebtef"
                className="animable"
              />
              <path
                d="M333.89,183.13a8.42,8.42,0,0,1,.25-2.21c.07-.25-.05-.35-.27-.22l-.91.52a1.37,1.37,0,0,0-.54.69,7.91,7.91,0,0,0-.26,2.22c0,.26.19.36.42.23l.9-.52A.9.9,0,0,0,333.89,183.13Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '333.159px 182.53px' }}
                id="elam11yoebug"
                className="animable"
              />
              <path
                d="M337.12,181.27a8.54,8.54,0,0,1,.25-2.22c.07-.25-.05-.34-.28-.21l-.9.52a1.24,1.24,0,0,0-.54.69,7.84,7.84,0,0,0-.26,2.21c0,.26.19.37.42.24l.9-.52A.9.9,0,0,0,337.12,181.27Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '336.389px 180.668px' }}
                id="el17kjiigxxv1"
                className="animable"
              />
              <path
                d="M233.81,241.91a8.47,8.47,0,0,1,.25-2.21c.07-.25-.05-.35-.27-.22l-.91.52a1.41,1.41,0,0,0-.54.69,7.91,7.91,0,0,0-.26,2.22c0,.26.19.36.42.23l.9-.52A.88.88,0,0,0,233.81,241.91Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '233.079px 241.31px' }}
                id="elikdkqpmjy"
                className="animable"
              />
              <path
                d="M237,240a8.49,8.49,0,0,1,.25-2.22c.06-.25,0-.34-.28-.21l-.9.52a1.24,1.24,0,0,0-.54.69,7.84,7.84,0,0,0-.26,2.21c0,.26.19.37.42.24l.9-.52A.9.9,0,0,0,237,240Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '236.269px 239.398px' }}
                id="eltr5itmihi28"
                className="animable"
              />
              <path
                d="M240.22,238a8.54,8.54,0,0,1,.25-2.22c.07-.25-.05-.34-.28-.21l-.9.52a1.24,1.24,0,0,0-.54.69,7.84,7.84,0,0,0-.26,2.21c0,.26.19.37.42.24l.9-.52A.9.9,0,0,0,240.22,238Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '239.489px 237.398px' }}
                id="el9fdmwrist9w"
                className="animable"
              />
              <path
                d="M243.43,236a8.42,8.42,0,0,1,.25-2.21c.06-.26-.05-.35-.28-.22l-.9.52a1.27,1.27,0,0,0-.54.69,7.91,7.91,0,0,0-.26,2.22c0,.26.19.36.42.23l.9-.52A.9.9,0,0,0,243.43,236Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '242.697px 235.399px' }}
                id="elzb18e2l213a"
                className="animable"
              />
              <path
                d="M246.64,234.07a8.94,8.94,0,0,1,.25-2.22c.07-.25,0-.34-.27-.21l-.91.52a1.33,1.33,0,0,0-.54.69,7.84,7.84,0,0,0-.26,2.21.26.26,0,0,0,.42.24l.91-.52A.93.93,0,0,0,246.64,234.07Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '245.911px 233.469px' }}
                id="elpyy0foww4y"
                className="animable"
              />
              <path
                d="M249.86,232.12a8.42,8.42,0,0,1,.25-2.21c.06-.26-.05-.35-.28-.22l-.9.52a1.27,1.27,0,0,0-.54.69,7.91,7.91,0,0,0-.26,2.22c0,.26.19.36.42.23l.9-.52A.9.9,0,0,0,249.86,232.12Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '249.127px 231.519px' }}
                id="el9ozpc4m9qtw"
                className="animable"
              />
              <path
                d="M253.08,230.18a8.54,8.54,0,0,1,.25-2.22c.06-.25-.05-.34-.28-.21l-.9.52a1.27,1.27,0,0,0-.54.69,7.88,7.88,0,0,0-.26,2.21c0,.26.19.37.42.24l.9-.52A.9.9,0,0,0,253.08,230.18Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '252.347px 229.578px' }}
                id="ele6l7gmhikx"
                className="animable"
              />
              <path
                d="M256.3,228.25a8.49,8.49,0,0,1,.25-2.22c.07-.25-.05-.35-.27-.22l-.91.53a1.34,1.34,0,0,0-.54.68,7.91,7.91,0,0,0-.26,2.22c0,.26.2.36.42.23l.91-.52A.9.9,0,0,0,256.3,228.25Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '255.569px 227.64px' }}
                id="eli56gwau90f"
                className="animable"
              />
              <path
                d="M259.53,226.32a8.49,8.49,0,0,1,.25-2.22c.06-.25,0-.35-.28-.22l-.9.53a1.25,1.25,0,0,0-.54.68,7.91,7.91,0,0,0-.26,2.22c0,.26.19.37.42.24l.9-.53A.88.88,0,0,0,259.53,226.32Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '258.799px 225.714px' }}
                id="elcqczjqr1dan"
                className="animable"
              />
              <path
                d="M262.76,224.39a8.42,8.42,0,0,1,.25-2.21c.06-.26-.05-.35-.28-.22l-.9.52a1.27,1.27,0,0,0-.54.69,7.91,7.91,0,0,0-.26,2.22c0,.26.19.36.42.23l.9-.52A.9.9,0,0,0,262.76,224.39Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '262.027px 223.789px' }}
                id="el7fk3hfv5tvy"
                className="animable"
              />
              <path
                d="M266,222.48a8.94,8.94,0,0,1,.25-2.22c.07-.25-.05-.35-.27-.22l-.91.53a1.34,1.34,0,0,0-.54.68,7.91,7.91,0,0,0-.26,2.22c0,.26.2.36.42.23l.91-.52A.9.9,0,0,0,266,222.48Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '265.269px 221.87px' }}
                id="elgft4vvfdo2b"
                className="animable"
              />
              <path
                d="M269.23,220.56a8.42,8.42,0,0,1,.25-2.21c.06-.25-.05-.35-.28-.22l-.9.52a1.27,1.27,0,0,0-.54.69,7.91,7.91,0,0,0-.26,2.22c0,.26.19.36.42.23l.9-.52A.9.9,0,0,0,269.23,220.56Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '268.497px 219.96px' }}
                id="elqr1fp8rq4mi"
                className="animable"
              />
              <path
                d="M272.47,218.66a8.49,8.49,0,0,1,.25-2.22c.06-.25-.05-.34-.28-.21l-.9.52a1.25,1.25,0,0,0-.54.68,8,8,0,0,0-.26,2.22c0,.26.19.37.42.24l.9-.53A.88.88,0,0,0,272.47,218.66Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '271.737px 218.058px' }}
                id="el8r1qpfmhu8h"
                className="animable"
              />
              <path
                d="M275.71,216.76a8.94,8.94,0,0,1,.25-2.22c.07-.25,0-.34-.27-.21l-.91.52a1.34,1.34,0,0,0-.54.68,8.34,8.34,0,0,0-.26,2.22.26.26,0,0,0,.42.24l.91-.53A.9.9,0,0,0,275.71,216.76Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '274.981px 216.159px' }}
                id="el8ylownlb3a"
                className="animable"
              />
              <path
                d="M279,214.86a8.42,8.42,0,0,1,.25-2.21c.07-.25,0-.35-.27-.22L278,213a1.37,1.37,0,0,0-.54.69,7.91,7.91,0,0,0-.26,2.22c0,.26.19.36.42.23l.9-.52A.9.9,0,0,0,279,214.86Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '278.236px 214.285px' }}
                id="elg1qr6zdy56d"
                className="animable"
              />
              <path
                d="M282.24,213a8.54,8.54,0,0,1,.25-2.22c.06-.25-.05-.34-.28-.21l-.9.52a1.24,1.24,0,0,0-.54.69,8.24,8.24,0,0,0-.27,2.21.26.26,0,0,0,.43.24l.9-.52A.92.92,0,0,0,282.24,213Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '281.501px 212.404px' }}
                id="elvhyigcbgqp8"
                className="animable"
              />
            </g>
            <g
              id="freepik--little-wign--inject-2"
              className="animable"
              style={{ transformOrigin: '184.995px 261.693px' }}
            >
              <path
                id="freepik--lttle-wing--inject-2"
                d="M215.58,255.89l-49.93-1.13a18,18,0,0,0-8,1.76l-3.24,1.88,43,10.12a4.12,4.12,0,0,0,3.53-.81Z"
                style={{ fill: 'rgb(240, 240, 240)', transformOrigin: '184.995px 261.693px' }}
                className="animable"
              />
              <path
                d="M201,267.71l14-11.33c-3,2.35-11.24,7.37-15.8,8.17-4.92.87-44.71-6.15-44.71-6.15l43,10.12A4.12,4.12,0,0,0,201,267.71Z"
                style={{ fill: 'rgb(224, 224, 224)', transformOrigin: '184.745px 262.502px' }}
                id="elh95h4gjq9z"
                className="animable"
              />
              <path
                d="M215.58,255.89l-49.93-1.13a18,18,0,0,0-8,1.76l-3.24,1.88h0c3.21-1.37,7.28-2.57,19-2s40.49.84,40.49.84Z"
                style={{ fill: 'rgb(250, 250, 250)', transformOrigin: '184.995px 256.579px' }}
                id="el0g0jjffvkmu"
                className="animable"
              />
            </g>
            <g
              id="freepik--wing--inject-2"
              className="animable"
              style={{ transformOrigin: '225.953px 216.335px' }}
            >
              <g
                id="freepik--wing--inject-2"
                className="animable"
                style={{ transformOrigin: '225.953px 216.335px' }}
              >
                <path
                  id="freepik--wing--inject-2"
                  d="M300,210.93a1.88,1.88,0,0,0-.72-.19l-136.86-9.12a9.86,9.86,0,0,0-7.58,3.42l-3.26,4.23L265.9,231c2.13.43,8.43-1.92,14.72-5.55l10-5.76C297.36,215.75,301.56,211.84,300,210.93Z"
                  style={{ fill: 'rgb(240, 240, 240)', transformOrigin: '225.953px 216.335px' }}
                  className="animable"
                />
                <path
                  d="M280.62,225.42l10-5.76a50.42,50.42,0,0,0,7-4.74c-5.72,4.63-29.75,9.26-42.6,8s-103.42-13.69-103.42-13.69L265.9,231C268,231.4,274.33,229.05,280.62,225.42Z"
                  style={{ fill: 'rgb(224, 224, 224)', transformOrigin: '224.61px 220.137px' }}
                  id="elzzse72abx7"
                  className="animable"
                />
                <path
                  d="M300,210.93a1.88,1.88,0,0,0-.72-.19l-136.86-9.12a9.86,9.86,0,0,0-7.58,3.42l-2.35,3.05h0c1.92-2.5,5.21-4.59,10.58-4.36s78.42,5.36,91.93,6,38.72,2.39,40.3,2.56c2,.21,4.13.86,2.65,2.29C300,212.82,300.84,211.43,300,210.93Z"
                  style={{ fill: 'rgb(250, 250, 250)', transformOrigin: '226.406px 208.1px' }}
                  id="elywjrqjqpwr"
                  className="animable"
                />
              </g>
              <path
                d="M248.81,218.81a102.94,102.94,0,0,0-13.32,6.41s-.22.78.88,1.42a4.78,4.78,0,0,0,2.47.51,74.47,74.47,0,0,0,10.59-7.29A.62.62,0,0,0,248.81,218.81Z"
                style={{ fill: '#90CAF9', transformOrigin: '242.558px 222.966px' }}
                id="elg46xdijj4hb"
                className="animable"
              />
              <g id="elllgngcimu3">
                <path
                  d="M248.81,218.81a102.94,102.94,0,0,0-13.32,6.41s-.22.78.88,1.42a4.78,4.78,0,0,0,2.47.51,74.47,74.47,0,0,0,10.59-7.29A.62.62,0,0,0,248.81,218.81Z"
                  style={{ opacity: '0.1', transformOrigin: '242.558px 222.966px' }}
                  className="animable"
                  id="eldux2p2kdjej"
                />
              </g>
              <g id="el5ntnor7czpo">
                <path
                  d="M236.37,226.64a4.78,4.78,0,0,0,2.47.51,74.47,74.47,0,0,0,10.59-7.29.6.6,0,0,0,.12-.82c0,.61-.57.93-4,3.17s-6.37,4.1-7.82,4.1a3,3,0,0,1-2.25-1.09S235.27,226,236.37,226.64Z"
                  style={{ opacity: '0.15', transformOrigin: '242.562px 223.1px' }}
                  className="animable"
                  id="elkr5xe3hx2bp"
                />
              </g>
              <path
                d="M220.52,215.38a79,79,0,0,0-10.43,5s-.17.62.7,1.12a3.69,3.69,0,0,0,1.94.4,59.46,59.46,0,0,0,8.28-5.7A.49.49,0,0,0,220.52,215.38Z"
                style={{ fill: '#90CAF9', transformOrigin: '215.619px 218.632px' }}
                id="elw7097x9nt79"
                className="animable"
              />
              <g id="elm150m7ihqjj">
                <path
                  d="M220.52,215.38a79,79,0,0,0-10.43,5s-.17.62.7,1.12a3.69,3.69,0,0,0,1.94.4,59.46,59.46,0,0,0,8.28-5.7A.49.49,0,0,0,220.52,215.38Z"
                  style={{ opacity: '0.1', transformOrigin: '215.619px 218.632px' }}
                  className="animable"
                  id="elv6oevvp6eu"
                />
              </g>
              <g id="el5enqt9mzzbs">
                <path
                  d="M210.79,221.51a3.69,3.69,0,0,0,1.94.4,59.46,59.46,0,0,0,8.28-5.7.49.49,0,0,0-.26-.87c.36.24.05.57-2.29,2.14s-4.92,3.5-6.1,3.62a3.61,3.61,0,0,1-2.27-.71S209.92,221,210.79,221.51Z"
                  style={{ opacity: '0.15', transformOrigin: '215.635px 218.629px' }}
                  className="animable"
                  id="el4qkm0nir6ku"
                />
              </g>
              <path
                d="M192.59,212.57a.37.37,0,0,0-.37-.63,58.18,58.18,0,0,0-7.53,3.62s-.12.45.51.82a2.75,2.75,0,0,0,1.42.29A42.4,42.4,0,0,0,192.59,212.57Z"
                style={{ fill: '#90CAF9', transformOrigin: '188.703px 214.295px' }}
                id="ely0xjryd221"
                className="animable"
              />
              <g id="elt01tc6dfq">
                <path
                  d="M192.59,212.57a.37.37,0,0,0-.37-.63,58.18,58.18,0,0,0-7.53,3.62s-.12.45.51.82a2.75,2.75,0,0,0,1.42.29A42.4,42.4,0,0,0,192.59,212.57Z"
                  style={{ opacity: '0.1', transformOrigin: '188.703px 214.295px' }}
                  className="animable"
                  id="el1iz7k06q8dn"
                />
              </g>
              <g id="eli0cn9hbxaf">
                <path
                  d="M185.2,216.38a2.75,2.75,0,0,0,1.42.29,42.4,42.4,0,0,0,6-4.1.37.37,0,0,0-.13-.65c.18.18-.17.65-2.11,1.88s-3.69,2.66-5.66,1.76C184.69,215.56,184.57,216,185.2,216.38Z"
                  style={{ opacity: '0.15', transformOrigin: '188.727px 214.298px' }}
                  className="animable"
                  id="el3cnaeezxhj2"
                />
              </g>
            </g>
            <path
              id="freepik--Window--inject-2"
              d="M363.5,166.51a5.38,5.38,0,0,0-2.26,3.64,54.21,54.21,0,0,1,21-4.61,9.87,9.87,0,0,0-2.79-2.36C373.54,162.28,365.67,164.83,363.5,166.51Z"
              style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '371.74px 166.571px' }}
              className="animable"
            />
            <g
              id="freepik--turbine--inject-2"
              className="animable"
              style={{ transformOrigin: '279.23px 213.705px' }}
            >
              <circle
                cx="269.4"
                cy="220.58"
                r="6.94"
                style={{ fill: 'rgb(224, 224, 224)', transformOrigin: '269.4px 220.58px' }}
                id="eli2gacge9ahm"
                className="animable"
              />
              <g id="el1lx02f3304j">
                <path
                  d="M276.34,220.58a6.92,6.92,0,0,0-10.79-5.76,11.68,11.68,0,0,0,2.86,10.54c.49.49-2.84.46-5.51-2.39a6.93,6.93,0,0,0,13.44-2.39Z"
                  style={{ opacity: '0.1', transformOrigin: '269.62px 220.58px' }}
                  className="animable"
                  id="el7gimqbc4ck3"
                />
              </g>
              <path
                d="M285.35,199.89c-6.71,0-18.16,11.28-18.78,12.08h0a5.19,5.19,0,0,0-1,3.37,14,14,0,0,0,6.32,11,5.14,5.14,0,0,0,3.6.78h0c1-.14,16.42-4.53,19.78-10.34Z"
                style={{ fill: 'rgb(235, 235, 235)', transformOrigin: '280.416px 213.535px' }}
                id="elepzo2wcyfil"
                className="animable"
              />
              <g id="eltl8qmu768vs">
                <path
                  d="M295.25,216.74l-9.44-16.07c-1.79.19-3.26.58-3.71,1.31-1.41,2.32-1.57,6.76,0,10.11s1.48,4.51-5.34,6.71-8.59,1.88-10.93-1.16a14.14,14.14,0,0,0,6,8.66,5.14,5.14,0,0,0,3.6.78h0C276.47,226.94,291.89,222.55,295.25,216.74Z"
                  style={{ opacity: '0.1', transformOrigin: '280.54px 213.905px' }}
                  className="animable"
                  id="eltdgob9ywmvh"
                />
              </g>
              <path
                d="M285.35,199.89c-6.71,0-18.16,11.28-18.78,12.08h0a4.78,4.78,0,0,0-1,2.7c.43-1.64,2.26-3.19,4.66-5.24a100,100,0,0,1,10.28-7.33c1.29-.63-.09,2.66,1.4,6.25l3.88-7.67Z"
                style={{ fill: 'rgb(250, 250, 250)', transformOrigin: '275.68px 207.28px' }}
                id="elug1z7m2reze"
                className="animable"
              />
              <path
                d="M296,213.47c0,4.63-3.25,6.51-7.27,4.19a16.09,16.09,0,0,1-7.27-12.58c0-4.64,3.26-6.52,7.27-4.2A16,16,0,0,1,296,213.47Z"
                style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '288.73px 209.27px' }}
                id="elyn66mggrbl"
                className="animable"
              />
              <g id="el0aaphj9gvotr">
                <path
                  d="M288.38,209.27l3.47-3.79-4.1,4.1Zm-.45-.47,2.37-4.57-2.9,5Zm-.55-.34,1.14-5.05L287,209Zm-.63-.19-.19-5.16,0,5.82Zm6.27-1.19-5,2.9.69-.13Zm-5.78,6,2.79,4.41-2.92-5.1Zm6.5-4.14-5.6,1.5.7,0Zm-5.92,3.83,3.81,3.51-4.12-4.14Zm-1.72-4.51-1.51-4.93,1.46,5.63Zm2.72,2.89,5.14-.24h-5.8Zm-.53,1.18,4.57,2.36-5-2.9Zm.34-.56,5,1.11-5.6-1.51Zm-4.31-.31-.18.28.88-.52Zm1,1.45,0,.74.53-1.71Zm-.72-1-.14.35.63-.64Zm.33.46-.08.48.6-1Zm1.68.82,1,2.86-.92-3.56Zm-.7-.09.24,1.52,0-2.6Zm-1.49-4-1.8-.86,2.25,1.39Zm-.58,2,1.16-.25h-.77Zm1.63-2.88-2.77-4.33,2.89,5.15Zm-.58.44-2.64-2.42,2.94,3.05Zm-.51,1.08-.19-.11-1.09-.08,1.55.51Zm.13.62-.27-.07-.76.14,1.07.09Z"
                  style={{
                    fill: 'rgb(255, 255, 255)',
                    opacity: '0.5',
                    transformOrigin: '288.105px 210.3px'
                  }}
                  className="animable"
                  id="el0rv3wl0o9j8"
                />
              </g>
              <path
                d="M287.47,212.1l5.64,5.64a.32.32,0,0,0,.32.07.91.91,0,0,0,.17-.09h0s-.05-.08-.13-.16l-5.74-5.75c-.08-.08-.07-.1,0,0l7.08,4.09a.17.17,0,0,0,.25-.1h0a.26.26,0,0,0-.11-.3l-7-4c-.1-.06-.09-.08,0-.05l7.24,1.94a.14.14,0,0,0,.19-.15v0a.34.34,0,0,0-.22-.26l-7.1-1.9c-.11,0-.11,0,0,0h6.78a.17.17,0,0,0,.17-.21h0a.27.27,0,0,0-.25-.2h-6.69c-.12,0-.12,0,0,0l6.12-1.64a.19.19,0,0,0,.13-.25h0a.23.23,0,0,0-.27-.14L288,210c-.11,0-.12,0,0-.05l5.35-3.09c.1-.06.15-.15.12-.21l-.06-.12a.43.43,0,0,1,0-.07s-.13,0-.23,0l-5.35,3.09c-.1,0-.11,0,0-.05l4.46-4.46a.23.23,0,0,0,0-.3h0a.19.19,0,0,0-.28,0l-4.49,4.49c-.08.08-.1.07-.05,0l3.36-5.82a.27.27,0,0,0,0-.32h0a.17.17,0,0,0-.26,0l-3.41,5.9c-.05.1-.08.09-.05,0l1.92-7.13a.32.32,0,0,0-.12-.32l0,0a.14.14,0,0,0-.23.09l-1.95,7.27c0,.11-.05.11-.05,0v-8.16a.26.26,0,0,0-.2-.25h0a.17.17,0,0,0-.2.17v8.24c0,.11,0,.11-.05,0L284,201c0-.11-.07-.2-.09-.19l0,0-.15.1a.31.31,0,0,0-.09.31l2.09,7.79c0,.11,0,.12-.05,0l-3.31-5.74c-.06-.1-.13-.09-.16,0a1.29,1.29,0,0,0,0,.19.59.59,0,0,0,.06.39l3.09,5.35c.06.1,0,.11,0,0l-3-3c-.08-.08-.13-.06-.13.06s0,.15,0,.22a.56.56,0,0,0,.17.36l2.68,2.69c.09.08.07.1,0,0l-2.29-1.32c-.1-.06-.15,0-.12.09s0,.12.05.18a.69.69,0,0,0,.25.31l1.9,1.1c.1.05.09.08,0,.05l-1.58-.43c-.11,0-.17,0-.13.15l0,.08a.46.46,0,0,0,.28.25l1.3.35c.11,0,.1,0,0,0h-1.09a.12.12,0,0,0-.11.19l0,0a.38.38,0,0,0,.3.19h.88c.11,0,.12,0,0,0l-.74.2a.16.16,0,0,0-.11.24h0a.26.26,0,0,0,.29.13l.65-.18c.11,0,.12,0,0,.05l-.56.33c-.1.06-.16.13-.14.18l0,.07a.86.86,0,0,0,.07.1c0,.06.15.06.25,0l.56-.33c.1-.06.11,0,0,0l-.47.48a.26.26,0,0,0,0,.32h0a.17.17,0,0,0,.26,0l.54-.53c.08-.08.1-.07,0,0l-.43.75a.38.38,0,0,0,0,.36l0,0c.06.1.16.09.22,0l.54-.93c.06-.1.08-.09.05,0l-.34,1.28a.46.46,0,0,0,.07.36l.06.07c.08.09.16.07.19,0l.42-1.56c0-.11.05-.11.05,0v2.18a.57.57,0,0,0,.14.36l.12.13c.08.09.15.06.15-.06v-2.61c0-.11,0-.11.05,0l1,3.61a.69.69,0,0,0,.22.33l.19.12c.1.07.15,0,.12-.08l-1.1-4.09c0-.11,0-.12.05,0l3.05,5.28a.59.59,0,0,0,.3.24l.19.06c.11,0,.15,0,.1-.12l-3.28-5.67C287.37,212,287.39,212,287.47,212.1Z"
                style={{ fill: 'rgb(55, 71, 79)', transformOrigin: '288.806px 209.157px' }}
                id="el178al6uyfjg"
                className="animable"
              />
              <path
                d="M290.79,208.13a.72.72,0,0,0-.46-.33h0s-3.69-.79-5.43.21a1.5,1.5,0,0,0-.64,1.4,4.78,4.78,0,0,0,2.17,3.75,1.5,1.5,0,0,0,1.53.15h0c1.74-1,2.9-4.6,2.9-4.6h0A.76.76,0,0,0,290.79,208.13Z"
                style={{ fill: 'rgb(235, 235, 235)', transformOrigin: '287.57px 210.478px' }}
                id="el5zkgq6zfw0t"
                className="animable"
              />
              <g id="el3uklssojgm6">
                <path
                  d="M287.77,211.13c-1.41.9-2.49-.18-2.81-1.3a1.62,1.62,0,0,1,.81-2.16,3,3,0,0,0-.88.33,1.5,1.5,0,0,0-.64,1.4,4.78,4.78,0,0,0,2.17,3.75,1.5,1.5,0,0,0,1.53.15h0c1.74-1,2.9-4.6,2.9-4.6h0a.76.76,0,0,0-.06-.57C290.85,208.7,289.18,210.22,287.77,211.13Z"
                  style={{ opacity: '0.1', transformOrigin: '287.56px 210.557px' }}
                  className="animable"
                  id="elcoudhrjputj"
                />
              </g>
              <path
                d="M290.85,208.7a.76.76,0,0,0-.06-.57.72.72,0,0,0-.46-.33h0s-3.69-.79-5.43.21a1.2,1.2,0,0,0-.53.73c.24-.46.94-.86,2.74-.91a11.81,11.81,0,0,1,3.25.24.39.39,0,0,0-.11.47c.11.3.47.39.61.17Z"
                style={{ fill: 'rgb(250, 250, 250)', transformOrigin: '287.625px 208.168px' }}
                id="eldcx6goz6g7k"
                className="animable"
              />
            </g>
          </g>
        </g>
        <defs>
          {' '}
          <filter id="active" height="200%">
            {' '}
            <feMorphology in="SourceAlpha" result="DILATED" operator="dilate" radius={2} />{' '}
            <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />{' '}
            <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />{' '}
            <feMerge>
              {' '}
              <feMergeNode in="OUTLINE" /> <feMergeNode in="SourceGraphic" />{' '}
            </feMerge>{' '}
          </filter>{' '}
          <filter id="hover" height="200%">
            {' '}
            <feMorphology in="SourceAlpha" result="DILATED" operator="dilate" radius={2} />{' '}
            <feFlood floodColor="#ff0000" floodOpacity="0.5" result="PINK" />{' '}
            <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />{' '}
            <feMerge>
              {' '}
              <feMergeNode in="OUTLINE" /> <feMergeNode in="SourceGraphic" />{' '}
            </feMerge>{' '}
            <feColorMatrix
              type="matrix"
              values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
            />{' '}
          </filter>
        </defs>
      </svg> */}
    </div>
  );
};

export default SplashScreen;
